import React, { useCallback, useRef, useState } from 'react';
import { createRoot } from 'react-dom/client';
import { GET, JSXMap, Overlay, POST, QueryDetail, QueryParam, READWITH, errorCatch, getLocator, pushStateHistoryModal, ycStorage } from 'fennec-ui';
import { Navigate, Route } from 'react-router';
import { FieldWrapper } from 'fennec-ui'
import MDEditor from '@uiw/react-md-editor';

import {
    MDXEditor,
    BlockTypeSelect,
    UndoRedo,
    CodeToggle,
    InsertCodeBlock,
    ListsToggle,
    InsertThematicBreak,
    InsertTable,
    BoldItalicUnderlineToggles,
    toolbarPlugin,
    headingsPlugin,
    listsPlugin,
    quotePlugin,
    thematicBreakPlugin,
    markdownShortcutPlugin,
    codeBlockPlugin,
    tablePlugin,
    directivesPlugin,
    linkDialogPlugin,
    frontmatterPlugin,
    imagePlugin,
    DiffSourceToggleWrapper
} from '@mdxeditor/editor'
import '@mdxeditor/editor/style.css'
import { CloseOutlined, DeleteOutlined, ExclamationCircleOutlined, FullscreenExitOutlined, FullscreenOutlined, IssuesCloseOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { useEffect } from 'react';
import { diffSourcePlugin } from '@mdxeditor/editor';
import { insertFrontmatter$ } from '@mdxeditor/editor';
import uuid from 'react-uuid';
import { Button, Upload } from 'antd';
import ImgCrop from 'antd-img-crop';
import { Image } from 'antd';
import { Spin } from 'antd';
import { Tooltip } from 'antd';
import { Modal } from 'antd';
import { useMemo } from 'react';
import YImage from '../YImage';
import { message } from 'antd';

var _ = require('lodash');
//-------------------------------------------------------------------
// Breadth-First Search (BFS) - поиск в ширину
// при условии, что мы имеем дело со смежным списком
// например, таким: adj = {A:[B,C,D], B:[E,F], ... }
function bfs(adj, s, t) {
    // adj - смежный список
    // s - начальная вершина
    // t - пункт назначения

    // инициализируем очередь
    let queue = []
    // добавляем s в очередь
    queue.push(s)
    // помечаем s как посещенную вершину во избежание повторного добавления в очередь
    s.visited = true
    while (queue.length > 0) {
        // удаляем первый (верхний) элемент из очереди
        let v = queue.shift()
        // abj[v] - соседи v
        for (let neighbor of adj[v]) {
            // если сосед не посещался
            if (!neighbor.visited) {
                // добавляем его в очередь
                queue.push(neighbor)
                // помечаем вершину как посещенную
                neighbor.visited = true
                // если сосед является пунктом назначения, мы победили
                if (neighbor === t) return true
            }
        }
    }
    // если t не обнаружено, значит пункта назначения достичь невозможно
    return false
}
// Depth-First Search (DFS) - поиск в глубину
// при условии, что мы имеем дело со смежным списком
// например, таким: adj = {A: [B,C], B:[D,F], ... }
function dfs(adj, v, t) {
    // adj - смежный список
    // v - посещенный узел (вершина)
    // t - пункт назначения

    // это общие случаи
    // либо достигли пункта назначения, либо уже посещали узел
    if (v === t) return true
    if (v.visited) return false

    // помечаем узел как посещенный
    v.visited = true
    // исследуем всех соседей (ближайшие соседние вершины) v
    for (let neighbor of adj[v]) {
        // если сосед не посещался
        if (!neighbor.visited) {
            // двигаемся по пути и проверяем, не достигли ли мы пункта назначения
            let reached = dfs(adj, neighbor, t)
            // возвращаем true, если достигли
            if (reached) return true
        }
    }
    // если от v до t добраться невозможно
    return false
}

//-------------------------------------------------------------------
const Aspects = {
    '1x1': 1,
    '4x3': 1.33333333333333,
    '16x9': 1.77777777777778,
    '3x1': 3,
    '2x1': 2,
    '3x2': 1.5,
    '5x1': 5,
    '5x2': 2.5,
    '5x3': 1.66666666666667,
    '5x4': 1.25,
    '6x5': 1.2,
    '7x2': 3.5,
    '7x4': 1.75,
    '8x1': 8,
    '15x4': 3.75,
    '16x5': 3.2,
    '16x10': 1.6,
    '19x10': 1.9,
    '21x9': 2.333333333,
    '25x16': 1.5625,
    '25x19': 1.31578947368421,
    '25x3': 8.33333333333333,
    '32x5': 6.4,
    '32x9': 3.555555556,
    '39x10': 3.9,
    '39x5': 7.8,
    '40x21': 1.9047619047619,
    '97x25': 3.88,
    'A0': 1.41379310344828,
    'A1': 1.41582491582492,
    'A2': 1.41428571428571,
    'A3': 1.41414141414141,
    'A4': 1.41428571428571,
    'A5': 1.41891891891892,
    'A6': 1.40952380952381,
    'A7': 1.41891891891892,
    'A8': 1.42307692307692,
    'A9': 1.40540540540541,
}
export const AspectsRatio = {
    _1x1: "1x1",
    _4x3: "4x3",
    _16x9: "16x9",
    _3x1: "3x1",
    _2x1: "2x1",
    _3x2: "3x2",
    _5x1: "5x1",
    _5x2: "5x2",
    _5x3: "5x3",
    _5x4: "5x4",
    _6x5: "6x5",
    _7x2: "7x2",
    _7x4: "7x4",
    _8x1: "8x1",
    _15x4: "15x4",
    _16x5: "16x5",
    _16x10: "16x10",
    _19x10: "19x10",
    _21x9: "21x9",
    _25x16: "25x16",
    _25x19: "25x19",
    _25x3: "25x3",
    _32x5: "32x5",
    _32x9: "32x9",
    _39x10: "39x10",
    _39x5: "39x5",
    _40x21: "40x21",
    _97x25: "97x25",
    A0: "A0",
    A1: "A1",
    A2: "A2",
    A3: "A3",
    A4: "A4",
    A5: "A5",
    A6: "A6",
    A7: "A7",
    A8: "A8",
    A9: "A9",
};
//-------------------------------------------------------------------
export function fire(props, component) {
    var div = document.createElement('div');
    const root = createRoot(div);
    // document.body.appendChild(div);
    const stack = [];
    const getStack = () => {
        return stack;
    };
    var currentConfig = {
        ...props,
        close: close,
        onCancel: (c) => {
            if (typeof props.onCancel === 'function') {
                props.onCancel(close);
            } else {
                close();
            }
        },
        onOk: () => {
            if (typeof props.onOk === 'function') {
                props.onOk(close);
            } else {
                close();
            }
        },
        visible: true
    };
    function destroy() {
        setTimeout(function () {
            root.unmount();
        });

        // var unmountResult = ReactDOM.unmountComponentAtNode(div);
        // if (unmountResult && div.parentNode) {
        //     div.parentNode.removeChild(div);
        // }
        // for (var len = arguments.length, args = new Array(len), key = 0; key < len; key++) {
        //     args[key] = arguments[key];
        // }
        // var triggerCancel = args.some(function (param) {
        //     return param && param.triggerCancel;
        // });

        // if (props.onCancel && triggerCancel) {
        //     props.onCancel.apply(props, args);
        // }
    }
    function render(props) {
        setTimeout(function () {
            var c = React.createElement(component, props, props.content);
            root.render(c);
            // ReactDOM.render(c, div);
        });
    }
    function setVisible(visible) {
        if (!visible) {
            var ctx = this;
            for (var len = arguments.length, args = new Array(len), key = 0; key < len; key++) {
                args[key] = arguments[key];
            }
            currentConfig = {
                ...props,
                visible: false,
                afterClose: function afterClose() {
                    if (typeof props.afterClose === 'function') {
                        props.afterClose();
                    }
                    destroy.apply(ctx, args);
                }
            };
            render(currentConfig);
        }
    }
    function close() {
        // console.log("back");
        window.history.back();
    }
    function update(configUpdate) {
        if (typeof configUpdate === 'function') {
            currentConfig = configUpdate(currentConfig);
        } else {
            currentConfig = { ...props, ...configUpdate };
        }
        render(currentConfig);
    }
    if (props.stackFunc) {
        stack.push(props.stackFunc)
    }
    pushStateHistoryModal(setVisible, getStack);
    render(currentConfig);
    return {
        destroy: close,
        update: update
    };
}
//-------------------------------------------------------------------
export function ycBucket(auth) {
    var bucketName = "federation"
    if (auth.appProfile != "prod") {
        bucketName = "federation-dev"
    }
    return bucketName;
}
//-------------------------------------------------------------------
// export const T = (props) => {
//     const { value, children } = props;
//     const translate = useSelector(REDUX_Translate.selector.object);
//     const [userConfig, setUserConfig] = useUserConfigContext();
//     let v = value || children;
//     return <>{t(v, translate, config)}</>
// };
export const t = (value, translate, config) => {
    let translateFunc = translate.bind({ translate, config });
    return translateFunc(value);
};
window.dict = {};
export function translate(value) {
    if (!_.isString(value)) return "";
    window.dict[value.toLowerCase().replaceAll(' ', '')] = value;

    if (this.config && this.translate && value) {
        let key = value.toLowerCase().replaceAll(' ', '');
        if (this.translate[key]) {
            let v = this.translate[key][(this.config.lang) ? this.config.lang : "ru"];
            if (!v || v === "") {
                return value;
            }
            return v
        }
    }
    return value;
}
//-----------------------------------------------------------------------------------
export const goTo = (href) => {
    var a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    a.href = href;
    a.target = "_blank"
    a.click();
    a.remove();
}
//-----------------------------------------------------------------------------------
export const isOrganizer = (user, eventID) => {
    // {ID: 1, name: 'Организатор'}
    return HasEventRoleID(user, eventID, 1)
}
export const isAdministrator = (user, eventID) => {
    // {ID: 2, name: 'Администратор'}
    return HasEventRoleID(user, eventID, 2)
}
export const isAnyAdministrator = (user, eventID) => {
    return isAdministrator(user, eventID) || isOrganizer(user, eventID) //|| isFederationAdministrator(user) || isFederationPresident(user)
}
export const isDancer = (user, eventID) => {
    // {ID: 3, name: 'Участник'}
    return HasEventRoleID(user, eventID, 3)
}
export const isMainJudge = (user, eventID) => {
    // {ID: 4, name: 'ГлавныйCудья'}
    return HasEventRoleID(user, eventID, 4)
}
export const isJudge = (user, eventID) => {
    // {ID: 5, name: 'Судья'}
    return HasEventRoleID(user, eventID, 5)
}
export const isAnyJudge = (user, eventID) => {
    return isJudge(user, eventID) || isMainJudge(user, eventID)
}
export const isPresenter = (user, eventID) => {
    // {ID: 6, name: 'Ведущий'}
    return HasEventRoleID(user, eventID, 6)
}
export const isDJ = (user, eventID) => {
    // {ID: 7, name: 'Диджей'}
    return HasEventRoleID(user, eventID, 7)
}
export const isViewerOnly = (user, eventID) => {
    // {ID: 8, name: 'Зритель'}
    return HasEventRoleID(user, eventID, 8)
}
export const isViewer = (user, eventID) => {
    // {ID: 8, name: 'Зритель'}
    return HasEventRoleID(user, eventID, 8) || isDancer(user, eventID)
}
//------------------------------------------------------------------------------------------------------
export const isFederationAdministrator = (user) => {
    // {ID: 4, name: 'АдминистраторФедерации'}
    return hasActiveRight({ userID: user.ID, tipPolzovatelyaID: 5 }, user.vseTipiPolzovatelei)
    // return HasRoleID(user, 4)
}
export const isFederationPresident = (user) => {
    // {ID: 3, name: 'ПрезидентФедерации'}
    return hasActiveRight({ userID: user.ID, tipPolzovatelyaID: 9 }, user.vseTipiPolzovatelei)
    // return HasRoleID(user, 3)
}
export const isAnyFederationAdministrator = (user) => {
    return isFederationAdministrator(user) || isFederationPresident(user)
}

export const HasEventRole = (user, eventID, name) => {
    if (user && user.eventUserUser) {
        for (let i = 0; i < user.eventUserUser.length; i++) {
            const element = user.eventUserUser[i];
            if (element.eventUserType.name === name && element.meropriyatieID == eventID) {
                return true;
            }
        }
    }
    return false;
};
export const HasEventRoleID = (user, eventID, roleID) => {
    if (user && user.eventUserUser) {
        for (let i = 0; i < user.eventUserUser.length; i++) {
            const element = user.eventUserUser[i];
            if (element.eventUserTypeID === roleID && element.meropriyatieID == eventID) {
                return true;
            }
        }
    }
    return false;
};
//-----------------------------------------------------------------------------------------------------
export const eventRole = (event, name) => {
    if (event?.eventUserMeropriyatie) {
        for (let i = 0; i < event.eventUserMeropriyatie.length; i++) {
            const element = event.eventUserMeropriyatie[i];
            if (element.eventUserType.name === name) {
                return true;
            }
        }
    }
    return false;
};
export const eventRoleID = (event, roleID) => {
    if (event?.eventUserMeropriyatie) {
        for (let i = 0; i < event.eventUserMeropriyatie.length; i++) {
            const element = event.eventUserMeropriyatie[i];
            if (element.eventUserTypeID === roleID) {
                return true;
            }
        }
    }
    return false;
};
export const eventRoleControler = (event) => {
    return (event?.controllersMeropriyatie && event?.controllersMeropriyatie.length)
};

export const eventRoleOrganizer = (event) => {
    // {ID: 1, name: 'Организатор'}
    return eventRoleID(event, 1)
}
export const eventRoleAdministrator = (event) => {
    // {ID: 2, name: 'Администратор'}
    return eventRoleID(event, 2)
}
export const eventRoleAnyAdministrator = (event) => {
    return eventRoleAdministrator(event) || eventRoleOrganizer(event) //|| eventRoleFederationAdministrator(user) || eventRoleFederationPresident(user)
}
export const eventRoleDancer = (event) => {
    // {ID: 3, name: 'Участник'}
    return eventRoleID(event, 3)
}
export const eventRoleMainJudge = (event) => {
    // {ID: 4, name: 'ГлавныйCудья'}
    return eventRoleID(event, 4)
}
export const eventRoleJudge = (event) => {
    // {ID: 5, name: 'Судья'}
    return eventRoleID(event, 5)
}
export const eventRoleAnyJudge = (event) => {
    return eventRoleJudge(event) || eventRoleMainJudge(event)
}
export const eventRolePresenter = (event) => {
    // {ID: 6, name: 'Ведущий'}
    return eventRoleID(event, 6)
}
export const eventRoleDJ = (event) => {
    // {ID: 7, name: 'Диджей'}
    return eventRoleID(event, 7)
}
export const eventRoleViewerOnly = (event) => {
    // {ID: 8, name: 'Зритель'}
    return eventRoleID(event, 8)
}
export const eventRoleViewer = (event) => {
    // {ID: 8, name: 'Зритель'}
    return eventRoleID(event, 8) || eventRoleDancer(event)
}
export const eventRoleSpecialguest = (event) => {
    // {ID: 9, name: 'Спец.гость'}
    return eventRoleID(event, 9)
}
export const eventRoleOperatorOBS = (event) => {
    // {ID: 10, name: 'ОператорOBS'}
    return eventRoleID(event, 10)
}
export const eventRoleChlenKomitetaPoSudeistvu = (event) => {
    // {ID: 11, name: 'Член комитета по судейству'}
    return eventRoleID(event, 11)
}
//-----------------------------------------------------------------------------------------------------
//-----------------------------------------------------------------------------------
// var count = countByFuncs(dancers, [
//     (e)=> e.user.genderID === 1,
//     (e)=> e.user.genderID === 2,
// ]);
// console.log(count);
// [7, 10] 
export function countByFuncs(array, funcs) {
    if (!funcs || !_.isArray(funcs) || funcs.length == 0) return;
    let counts = funcs.map(e => 0);
    if (!array) return counts;
    if (!_.isArray(array)) return counts;
    if (array.length == 0) return counts;

    for (let i = 0; i < array.length; i++) {
        const element = array[i];
        for (let f = 0; f < funcs.length; f++) {
            const fun = funcs[f];
            if (fun(element)) counts[f] += 1;
        }
    }
    return counts;
}

// var count = countByObjFuncs(dancers, {
//     male: (e)=> e.user.genderID === 1,
//     female: (e)=> e.user.genderID === 2,
// })
// console.log(count);
// {male: 7, female: 10}
export function countByObjFuncs(array, objFuncs) {
    if (!objFuncs) return;
    let counts = {};
    for (const key in objFuncs) {
        if (Object.hasOwnProperty.call(objFuncs, key)) {
            counts[key] = 0;
        }
    }
    if (!array) return counts;
    if (!_.isArray(array)) return counts;
    if (array.length == 0) return counts;

    for (let i = 0; i < array.length; i++) {
        const element = array[i];
        for (const key in objFuncs) {
            if (Object.hasOwnProperty.call(objFuncs, key)) {
                const fun = objFuncs[key];
                if (_.isFunction(fun)) {
                    if (fun(element)) counts[key] += 1;
                }
            }
        }
    }
    return counts;
}
//-----------------------------------------------------------------------------------
export function getRandomInt(max) {
    return Math.floor(Math.random() * max);
}
export function getRandomColor() {
    var letters = '0123456789ABCDEF';
    var color = '#';
    for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
}
export function generateRandomColorRgb() {
    const red = Math.floor(Math.random() * 256);
    const green = Math.floor(Math.random() * 256);
    const blue = Math.floor(Math.random() * 256);
    return "rgb(" + red + ", " + green + ", " + blue + ")";
}
export function getIndexColorAlt(idx) {
    const pack = [
        "#8fa38a",
        "#a7b0e5",
        "#d246fc",
        "#491359",
        "#afaea7",
        "#473c34",
        "#ccd1ab",
        "#d1ccce",
        "#47434f",
        "#244260",
        "#f9b6a2",
        "#113a1e",
        "#337a3b",
        "#c2d3c9",
        "#d60e86",
        "#422e07",
        "#540d1f",
        "#0c0b0c",
        "#d3fff6",
        "#bf4c97",
        "#38252c",
        "#97e510",
        "#4c211d",
        "#6e8c91",
        "#b3aded",
        "#000000",
        "#efd775",
        "#6d6c6c",
        "#ffbdbc",
        "#5a11ad",
        "#568e02",
        "#16153a",
        "#727271",
        "#273c51",
        "#030502",
        "#000000",
        "#dff7de",
        "#82cacc",
        "#3a3a37",
        "#c1aec1",
    ]
    return _.get(pack, `[${Math.abs(idx) % pack.length}]`)
}

/**
 * Преобразует полупрозрачный цвет в сплошной с учетом цвета фона,
 * сохраняя визуальное восприятие при наложении.
 *
 * @param {number} r - Красный канал переднего плана (0-255)
 * @param {number} g - Зеленый канал переднего плана (0-255)
 * @param {number} b - Синий канал переднего плана (0-255)
 * @param {number} alpha - Степень прозрачности от 0.0 (полностью прозрачный) до 1.0 (непрозрачный)
 * @param {{r: number, g: number, b: number}} [bgColor={r: 255, g: 255, b: 255}] - Цвет фона в виде объекта RGB
 * @returns {{r: number, g: number, b: number}} Итоговый сплошной цвет
 */
export function convertToOpaque(r, g, b, alpha, bgColor = { r: 255, g: 255, b: 255 }) {
    // Ограничиваем значения каналов и альфы допустимыми пределами
    const clamp = (val, min, max) => Math.min(Math.max(val, min), max);

    const fg = {
        r: clamp(r, 0, 255),
        g: clamp(g, 0, 255),
        b: clamp(b, 0, 255)
    };
    const a = clamp(alpha, 0, 1);
    const background = {
        r: clamp(bgColor.r, 0, 255),
        g: clamp(bgColor.g, 0, 255),
        b: clamp(bgColor.b, 0, 255)
    };

    // Если цвет полностью прозрачный или фон не задан белым/другим, возвращаем просто фон
    if (a === 0) return background;
    // Если цвет полностью непрозрачный, возвращаем его как есть
    if (a === 1) return fg;

    const resultR = Math.round(fg.r * a + background.r * (1 - a));
    const resultG = Math.round(fg.g * a + background.g * (1 - a));
    const resultB = Math.round(fg.b * a + background.b * (1 - a));

    // return {
    //     r: resultR,
    //     g: resultG,
    //     b: resultB
    // };
    return `rgb(${resultR}, ${resultG}, ${resultB})`;
}

export function getRGBAColor(r, g, b, alfa = 0.5) {
    return `rgba(${r}, ${g}, ${b},${alfa})`
}
export function getIndexColorLighter(idx, alfa = 0.5) {
    const background = { r: 255, g: 255, b: 255 };
    const pack = [
        convertToOpaque(77, 128, 204, alfa, background),
        convertToOpaque(57, 112, 108, alfa, background),
        convertToOpaque(16, 17, 45, alfa, background),
        convertToOpaque(186, 102, 123, alfa, background),
        convertToOpaque(82, 168, 11, alfa, background),
        convertToOpaque(186, 115, 124, alfa, background),
        convertToOpaque(137, 112, 20, alfa, background),
        convertToOpaque(252, 250, 204, alfa, background),
        convertToOpaque(216, 195, 4, alfa, background),
        convertToOpaque(72, 114, 78, alfa, background),
        convertToOpaque(36, 38, 12, alfa, background),
        convertToOpaque(132, 80, 54, alfa, background),
        convertToOpaque(191, 207, 239, alfa, background),
        convertToOpaque(67, 91, 36, alfa, background),
        convertToOpaque(1, 19, 33, alfa, background),
        convertToOpaque(20, 16, 14, alfa, background),
        convertToOpaque(178, 53, 138, alfa, background),
        convertToOpaque(28, 43, 32, alfa, background),
        convertToOpaque(15, 6, 14, alfa, background),
        convertToOpaque(21, 153, 115, alfa, background),
        convertToOpaque(12, 17, 30, alfa, background),
        convertToOpaque(234, 239, 232, alfa, background),
        convertToOpaque(48, 124, 39, alfa, background),
        convertToOpaque(152, 168, 173, alfa, background),
        convertToOpaque(140, 53, 145, alfa, background),
        convertToOpaque(108, 68, 124, alfa, background),
        convertToOpaque(43, 48, 45, alfa, background),
        convertToOpaque(31, 42, 71, alfa, background),
        convertToOpaque(63, 91, 59, alfa, background),
        convertToOpaque(18, 0, 22, alfa, background),
        convertToOpaque(172, 226, 197, alfa, background),
        convertToOpaque(64, 91, 63, alfa, background),
        convertToOpaque(145, 117, 58, alfa, background),
        convertToOpaque(94, 89, 91, alfa, background),
        convertToOpaque(89, 122, 163, alfa, background),
        convertToOpaque(58, 36, 47, alfa, background),
        convertToOpaque(32, 10, 53, alfa, background),
        convertToOpaque(127, 83, 170, alfa, background),
        convertToOpaque(47, 68, 9, alfa, background),
        convertToOpaque(175, 181, 209, alfa, background),
    ]
    // const pack = [
    //     `rgba(77, 128, 204,${alfa})`,
    //     `rgba(57, 112, 108,${alfa})`,
    //     `rgba(16, 17, 45,${alfa})`,
    //     `rgba(186, 102, 123,${alfa})`,
    //     `rgba(82, 168, 11,${alfa})`,
    //     `rgba(186, 115, 124,${alfa})`,
    //     `rgba(137, 112, 20,${alfa})`,
    //     `rgba(252, 250, 204,${alfa})`,
    //     `rgba(216, 195, 4,${alfa})`,
    //     `rgba(72, 114, 78,${alfa})`,
    //     `rgba(36, 38, 12,${alfa})`,
    //     `rgba(132, 80, 54,${alfa})`,
    //     `rgba(191, 207, 239,${alfa})`,
    //     `rgba(67, 91, 36,${alfa})`,
    //     `rgba(1, 19, 33,${alfa})`,
    //     `rgba(20, 16, 14,${alfa})`,
    //     `rgba(178, 53, 138,${alfa})`,
    //     `rgba(28, 43, 32,${alfa})`,
    //     `rgba(15, 6, 14,${alfa})`,
    //     `rgba(21, 153, 115,${alfa})`,
    //     `rgba(12, 17, 30,${alfa})`,
    //     `rgba(234, 239, 232,${alfa})`,
    //     `rgba(48, 124, 39,${alfa})`,
    //     `rgba(152, 168, 173,${alfa})`,
    //     `rgba(140, 53, 145,${alfa})`,
    //     `rgba(108, 68, 124,${alfa})`,
    //     `rgba(43, 48, 45,${alfa})`,
    //     `rgba(31, 42, 71,${alfa})`,
    //     `rgba(63, 91, 59,${alfa})`,
    //     `rgba(18, 0, 22,${alfa})`,
    //     `rgba(172, 226, 197,${alfa})`,
    //     `rgba(64, 91, 63,${alfa})`,
    //     `rgba(145, 117, 58,${alfa})`,
    //     `rgba(94, 89, 91,${alfa})`,
    //     `rgba(89, 122, 163,${alfa})`,
    //     `rgba(58, 36, 47,${alfa})`,
    //     `rgba(32, 10, 53,${alfa})`,
    //     `rgba(127, 83, 170,${alfa})`,
    //     `rgba(47, 68, 9,${alfa})`,
    //     `rgba(175, 181, 209,${alfa})`,
    // ]
    return _.get(pack, `[${Math.abs(idx) % pack.length}]`)
}
export function getIndexColor(idx) {
    // "#003f5c"
    // "#2f4b7c"
    // "#665191"
    // "#a05195"
    // "#d45087"
    // "#f95d6a"
    // "#ff7c43"
    // "#ffa600"

    const pack = [
        "#4b0f9e",
        "#058425",
        "#a2a717",
        "#e5066e",
        "#080b68",
        "#07756a",
        "#d58b00",
        "#0f9e88",
        "#032c7c",
        "#3d0575",
        "#bc0771",
        "#0a696b",
        "#ef0499",
        "#930b01",
        "#c613a3",
        "#bf7a03",
        "#0a8a91",
        "#647c04",
        "#013468",
        "#330a7f",
        "#b602d6",
        "#e57e09",
        "#399304",
        "#099e44",
        "#67890b",
        "#e2148c",
        "#068c01",
        "#22048e",
        "#75a009",
        "#01607a",
        "#0d037c",
        "#cebd06",
        "#b5121a",
        "#018977",
        "#207c04",
        "#300291",
        "#077f5d",
    ]
    return _.get(pack, `[${Math.abs(idx) % pack.length}]`)
}
// Usage
// function App() {
//     const [hoverRef, isHovered] = useHover();
//     return <div ref={hoverRef}>{isHovered ? "😁" : "☹️"}</div>;
// }
// Hook
export function useHover() {
    const [value, setValue] = useState(false);

    // Wrap in useCallback so we can use in dependencies below
    const handleMouseOver = useCallback(() => setValue(true), []);
    const handleMouseOut = useCallback(() => setValue(false), []);

    // Keep track of the last node passed to callbackRef
    // so we can remove its event listeners.
    const ref = useRef();

    // Use a callback ref instead of useEffect so that event listeners
    // get changed in the case that the returned ref gets added to
    // a different element later. With useEffect, changes to ref.current
    // wouldn't cause a rerender and thus the effect would run again.
    const callbackRef = useCallback(
        node => {
            if (ref.current) {
                ref.current.removeEventListener("mouseover", handleMouseOver);
                ref.current.removeEventListener("mouseout", handleMouseOut);
            }

            ref.current = node;

            if (ref.current) {
                ref.current.addEventListener("mouseover", handleMouseOver);
                ref.current.addEventListener("mouseout", handleMouseOut);
            }
        },
        [handleMouseOver, handleMouseOut]
    );

    return [callbackRef, value];
}
export function useFocus() {
    const [value, setValue] = useState(false);

    // Wrap in useCallback so we can use in dependencies below
    const handleFocus = useCallback(() => setValue(true), []);
    const handleBlur = useCallback(() => setValue(false), []);

    // Keep track of the last node passed to callbackRef
    // so we can remove its event listeners.
    const ref = useRef();

    // Use a callback ref instead of useEffect so that event listeners
    // get changed in the case that the returned ref gets added to
    // a different element later. With useEffect, changes to ref.current
    // wouldn't cause a rerender and thus the effect would run again.
    const callbackRef = useCallback(
        node => {
            console.log(ref, ref.current);
            if (ref.current) {
                ref.current.removeEventListener("focus", handleFocus);
                ref.current.removeEventListener("blur", handleBlur);
            }

            ref.current = node;

            if (ref.current) {
                ref.current.addEventListener("focus", handleFocus);
                ref.current.addEventListener("blur", handleBlur);
            }
        },
        [handleFocus, handleBlur]
    );

    return [callbackRef, value];
}
//-------------------------------------------------------------------------------------------
// Администратор
// АдминистраторКоллективаФедерации
// АдминистраторКонференции
// АдминистраторМероприятийРО
// АдминистраторМероприятия
// АдминистраторОбщегоСобрания
// АдминистраторОрганизатораФедерации
// АдминистраторОтделения
// АдминистраторПарыФедерации
// АдминистраторПравленияФедерации
// АдминистраторРегПравления
// АдминистраторФедерации
// АдминистраторШколыФедерации
// ВладелецШколыФедерации
// Инфраструктурщик
// МладшийАдминистратор
// ОбычныйПользователь
// ОрганизаторФедерации
// ПредседательПравленияОтделения
// ПрезидентФедерации
// ПреподавательФедерации
// ПреподавательШколы
// РевизорОтделения
// РевизорФедерации
// СудьяФедерации
// СуперАдмин
// ТанцорФедерации
// УченикШколы
// ЧленПравленияОтделения
// ЧленПравленияФедерации
// ЧленФедерации

export function ObjectsFromRoles(field, roles, active) {
    const obj = {}
    if (roles && roles.length > 0) {
        for (let i = 0; i < roles.length; i++) {
            const vtp = roles[i];
            let f = _.get(vtp, field)
            if (f && !vtp.dokumentOtmeniZapisiID && ((active) ? vtp.dokumentZapisiID && vtp.dokumentPodtverzhdeniyaID : true)) {
                if (!obj[f.ID]) {
                    obj[f.ID] = { ...f }
                }
                if (!obj[f.ID]._role) {
                    obj[f.ID]._role = _.set({ ...vtp }, field, undefined)
                }
            }
        }
    }
    return Object.values(obj)
}
export function getFromRoles(state, field, rolesNames, active) {
    if(!state) return;
    let roles = [];
    for (let i = 0; i < rolesNames.length; i++) {
        const e = rolesNames[i];
        let x = state.role_by_name[e]
        if (x) {
            roles.push(...x)
        }
    }
    return ObjectsFromRoles(field, roles, active)
}
export function regionalnoeOtdelenieFromRoles(roles, active) {
    return ObjectsFromRoles("regionalnoeOtdelenie", roles, active)
}
export function getRregionalnoeOtdelenieFromRoles(rolesNames, active) {
    return function (state) {
        let roles = [];
        for (let i = 0; i < rolesNames.length; i++) {
            const e = rolesNames[i];
            let x = state.home.role_by_name[e]
            if (x) {
                roles.push(...x)
            }
        }
        return ObjectsFromRoles("regionalnoeOtdelenie", roles, active)
    }
}
export function chlenFederatsiiFromRoles(roles, active) {
    return ObjectsFromRoles("chlenFederatsii", roles, active)
}
export function getChlenFederatsiiFromRoles(rolesNames, active) {
    return function (state) {
        let roles = [];
        for (let i = 0; i < rolesNames.length; i++) {
            const e = rolesNames[i];
            let x = state.home.role_by_name[e]
            if (x) {
                roles.push(...x)
            }
        }
        return ObjectsFromRoles("chlenFederatsii", roles, active)
    }
}
export function tantsorFromRoles(roles, active) {
    return ObjectsFromRoles("tantsor", roles, active)
}
export function getTantsorFromRoles(rolesNames, active) {
    return function (state) {
        let roles = [];
        for (let i = 0; i < rolesNames.length; i++) {
            const e = rolesNames[i];
            let x = state.home.role_by_name[e]
            if (x) {
                roles.push(...x)
            }
        }
        return ObjectsFromRoles("tantsor", roles, active)
    }
}
export function shkolaFromRoles(roles, active) {
    return ObjectsFromRoles("shkola", roles, active)
}
export function getShkolaFromRoles(rolesNames, active) {
    return function (state) {
        let roles = [];
        for (let i = 0; i < rolesNames.length; i++) {
            const e = rolesNames[i];
            let x = state.home.role_by_name[e]
            if (x) {
                roles.push(...x)
            }
        }
        return ObjectsFromRoles("shkola", roles, active)
    }
}
export function paraFromRoles(roles, active) {
    return ObjectsFromRoles("para", roles, active)
}
export function getParaFromRoles(rolesNames, active) {
    return function (state) {
        let roles = [];
        for (let i = 0; i < rolesNames.length; i++) {
            const e = rolesNames[i];
            let x = state.home.role_by_name[e]
            if (x) {
                roles.push(...x)
            }
        }
        return ObjectsFromRoles("para", roles, active)
    }
}
export function kollektivFromRoles(roles, active) {
    return ObjectsFromRoles("kollektiv", roles, active)
}
export function getKollektivFromRoles(rolesNames, active) {
    return function (state) {
        let roles = [];
        for (let i = 0; i < rolesNames.length; i++) {
            const e = rolesNames[i];
            let x = state.home.role_by_name[e]
            if (x) {
                roles.push(...x)
            }
        }
        return ObjectsFromRoles("kollektiv", roles, active)
    }
}
export function prepodavatelFromRoles(roles, active) {
    return ObjectsFromRoles("prepodavatel", roles, active)
}
export function getPrepodavatelFromRoles(rolesNames, active) {
    return function (state) {
        let roles = [];
        for (let i = 0; i < rolesNames.length; i++) {
            const e = rolesNames[i];
            let x = state.home.role_by_name[e]
            if (x) {
                roles.push(...x)
            }
        }
        return ObjectsFromRoles("prepodavatel", roles, active)
    }
}
export function sudyaFromRoles(roles, active) {
    return ObjectsFromRoles("sudya", roles, active)
}
export function getSudyaFromRoles(rolesNames, active) {
    return function (state) {
        let roles = [];
        for (let i = 0; i < rolesNames.length; i++) {
            const e = rolesNames[i];
            let x = state.home.role_by_name[e]
            if (x) {
                roles.push(...x)
            }
        }
        return ObjectsFromRoles("sudya", roles, active)
    }
}
export function organizatorFromRoles(roles, active) {
    return ObjectsFromRoles("organizator", roles, active)
}
export function getOrganizatorFromRoles(rolesNames, active) {
    return function (state) {
        let roles = [];
        for (let i = 0; i < rolesNames.length; i++) {
            const e = rolesNames[i];
            let x = state.home.role_by_name[e]
            if (x) {
                roles.push(...x)
            }
        }
        return ObjectsFromRoles("organizator", roles, active)
    }
}
export function meropriyatieFromRoles(roles, active) {
    return ObjectsFromRoles("meropriyatie", roles, active)
}
export function getMeropriyatieFromRoles(rolesNames, active) {
    return function (state) {
        let roles = [];
        for (let i = 0; i < rolesNames.length; i++) {
            const e = rolesNames[i];
            let x = state.home.role_by_name[e]
            if (x) {
                roles.push(...x)
            }
        }
        return ObjectsFromRoles("meropriyatie", roles, active)
    }
}
//-------------------------------------------------------------------------------------------
// Проверка прав пользователя user на администрирование мероприятия event.
// hasAllAdminRights - true указывает что у пользователя должны быть повышенные права (такие как создания комиссий, ячеек, промокодов)
// Если hasAllAdminRights = true, то для АдминистраторовМероприятия тип vse_tipi_polzovatelei.TipPolzovatelyaID=30, доспуп закрыт!!!
export function isMyEvent(event, user, hasAllAdminRights) {
    // event - текущее мероприятие которое надо проверить
    // user - пользователь с правами

    //Если достаточно наличия прав АдминистраторМероприятия (30)
    if (!hasAllAdminRights) {
        if (hasActiveRight({
            userID: user.ID,
            tipPolzovatelyaID: 30,
            meropriyatieID: event.ID
        }, user.vseTipiPolzovatelei)) {
            return true;
        }
    }

    if (!event.organizatorFederatsiyaID &&
        !event.organizatorRegionalnoeOtdelenieID &&
        !event.organizatorMeropriyatiyaID &&
        !event.organizatorShkolaID) {
        return false;
    }

    if (event.organizatorFederatsiyaID > 0) {
        if (!hasActiveRight({ userID: user.ID, tipPolzovatelyaID: 5 }, user.vseTipiPolzovatelei) &&
            !hasActiveRight({ userID: user.ID, tipPolzovatelyaID: 9 }, user.vseTipiPolzovatelei)) {
            return false;
        }
    } else if (event.organizatorRegionalnoeOtdelenieID > 0) {
        if (!hasActiveRight({
            userID: user.ID,
            tipPolzovatelyaID: 15,
            regionalnoeOtdelenieID: event.organizatorRegionalnoeOtdelenieID
        }, user.vseTipiPolzovatelei) &&
            !hasActiveRight({
                userID: user.ID,
                tipPolzovatelyaID: 29,
                regionalnoeOtdelenieID: event.organizatorRegionalnoeOtdelenieID
            }, user.vseTipiPolzovatelei)) {
            return false;
        }
    } else if (event.organizatorMeropriyatiyaID > 0) {
        if (!hasActiveRight({
            userID: user.ID,
            tipPolzovatelyaID: 23,
            organizatorID: event.organizatorMeropriyatiyaID
        }, user.vseTipiPolzovatelei) &&
            !hasActiveRight({
                userID: user.ID,
                tipPolzovatelyaID: 25,
                organizatorID: event.organizatorMeropriyatiyaID
            }, user.vseTipiPolzovatelei)) {
            return false;
        }
    } else if (event.organizatorShkolaID > 0) {
        if (!hasActiveRight({
            userID: user.ID,
            tipPolzovatelyaID: 18,
            shkolaID: event.organizatorShkolaID
        }, user.vseTipiPolzovatelei) &&
            !hasActiveRight({
                userID: user.ID,
                tipPolzovatelyaID: 19,
                shkolaID: event.organizatorShkolaID
            }, user.vseTipiPolzovatelei)) {
            return false;
        }
    }

    return true; // false - не моё мероприятие
};

export function hasActiveRight(params, vseTipiPolzovatelei) { //params - object type VseTipiPolzovatelei
    if (!params || !vseTipiPolzovatelei || !vseTipiPolzovatelei.length) {
        return false;
    }

    let objects = getRights(params, vseTipiPolzovatelei);
    if (!objects || !objects.length) {
        return false;
    }

    for (let i = 0; i < objects.length; i++) {
        let object = objects[i]
        if (object && object.dokumentZapisiID > 0 && object.dokumentPodtverzhdeniyaID > 0 && !object.dokumentOtmeniZapisiID) {
            return true;
        }
    }

    return false;
}

export function getRights(params, vseTipiPolzovatelei) { //params - object type VseTipiPolzovatelei
    if (!params || !vseTipiPolzovatelei || !vseTipiPolzovatelei.length) {
        return;
    }

    let result = [];

    for (let prop in params) {
        if (!(prop in vseTipiPolzovatelei[0])) {
            console.error('Не найдено свойство "' + prop + '" в объекте VseTipiPolzovatelei')
            return
        }
    }


    for (let i = 0; i < vseTipiPolzovatelei.length; i++) {
        const item = vseTipiPolzovatelei[i];

        if (params.userID > 0 && params.userID !== item.userID) {
            continue;
        }
        if (params.tipPolzovatelyaID > 0 && params.tipPolzovatelyaID !== item.tipPolzovatelyaID) {
            continue;
        }
        if (params.regionalnoeOtdelenieID > 0 && params.regionalnoeOtdelenieID !== item.regionalnoeOtdelenieID) {
            continue;
        }
        if (params.chlenFederatsiiID > 0 && params.chlenFederatsiiID !== item.chlenFederatsiiID) {
            continue;
        }
        if (params.tantsorID > 0 && params.tantsorID !== item.tantsorID) {
            continue
        }
        if (params.shkolaID > 0 && params.shkolaID !== item.shkolaID) {
            continue
        }
        if (params.paraID > 0 && params.paraID !== item.paraID) {
            continue
        }
        if (params.kollektivID > 0 && params.kollektivID !== item.kollektivID) {
            continue
        }
        if (params.prepodavatelID > 0 && params.prepodavatelID !== item.prepodavatelID) {
            continue
        }
        if (params.sudyaID > 0 && params.sudyaID !== item.sudyaID) {
            continue
        }
        if (params.organizatorID > 0 && params.organizatorID !== item.organizatorID) {
            continue
        }
        if (params.meropriyatieID > 0 && params.meropriyatieID !== item.meropriyatieID) {
            continue
        }

        result.push(item);
    }

    return result;
}

export const item = (level, key) => {
    var levelkey = key || xdefault(level, levelkey)
    var i = level.find((i, index) => {
        const key = i.uuid || i.key || index;
        return key === levelkey
    })
    if (!i) {
        for (let i = 0; i < level.length; i++) {
            const element = level[i];
            if (element.group) {
                i = item(element.group, levelkey)
            }
            if (i) break;
        }
    }
    return i;
}
export const xdefault = (level, levelkey) => {
    if (level.length <= 0) return "";
    var item = level.find((item, index) => {
        const key = item.uuid || item.key || index;
        return key === levelkey
    })
    if (item) {
        const key = item.uuid || item.key;
        return key
    } else {
        var def = level.find((item) => {
            return item.default && item.default === true
        })
        if (!def) {
            for (let i = 0; i < level.length; i++) {
                const element = level[i];
                if (element.group) {
                    var d = xdefault(element.group, levelkey)
                    if (d) {
                        return d.uuid;
                    }
                }
            }
            return level[0].uuid;
        }
        if (def) {
            return def.uuid;
        }
    }
    return ""
};
export const roles = (item) => {
    var arr = []
    if (item.role) {
        arr = arr.concat(item.role)
    }
    if (item.menu) {
        arr = arr.concat(item.menu.map(element => roles(element)).flat(Infinity).filter(f => f && (!item.role || item.role.findIndex(x => x.ID === f.ID) === -1)))
    }
    if (item.group) {
        arr = arr.concat(item.group.map(element => roles(element)).flat(Infinity).filter(f => f && (!item.role || item.role.findIndex(x => x.ID === f.ID) === -1)))
    }
    return arr;
};
export const access = (item, role_by_id) => {
    if (role_by_id[5] || role_by_id[9]) {
        return true
    }

    return roles(item).findIndex(i => {
        if (role_by_id[i.ID]) {
            return role_by_id[i.ID].filter(r =>
                r.dokumentZapisiID && r.dokumentPodtverzhdeniyaID && !r.dokumentOtmeniZapisiID
            ).length > 0
        }
    }) >= 0
};
export const defaultRoute = (m, role_by_id) => {
    var d = m.find(e => e.default && access(e, role_by_id) /*&& !e.hidden*/)
    if (d) {
        return <Route key={"index-" + d.uuid} index element={<Navigate replace to={d.uuid} />} />
    }
    var d1 = m.filter(e => access(e, role_by_id) /*&& !e.hidden*/)
    if (d1.length) {
        return <Route key={"index-" + d1[0].uuid} index element={<Navigate replace to={d1[0].uuid} />} />
    }
}
export const view = (item) => {
    if (item.view) {
        return item.view();
    }
    return true;
};
export const level = (level, levelkey, role_by_id) => {
    if (levelkey === "") {
        return level.filter(item => {
            return !item.hidden && access(item, role_by_id) && view(item);
        });
    }
    var i = item(level, levelkey)
    if (i && i.menu) {
        return i.menu.filter(ii => {
            return !ii.hidden && access(ii, role_by_id) && view(ii);
        });
    }
    if (i && i.group) {
        return i.group.filter(ii => {
            return !ii.hidden && access(ii, role_by_id) && view(ii);
        });
    }
    return [];
}

//------------------------------------------------------------------------------
// FSM
//------------------------------------------------------------------------------
export const HasAnswer = (context, questionID, answerContext) => {
    if (!context || !context.contextAnswerContext) return false;
    for (let i = 0; i < context.contextAnswerContext.length; i++) {
        const answer = context.contextAnswerContext[i];
        if (answerContext) {
            if (answer.questionID === questionID && answer.answerContext === answerContext) {
                return true;
            }
        } else {
            if (answer.questionID === questionID) {
                return true;
            }
        }
    }
    return false;
};
export const GetAnswer = (context, questionID, answerContext) => {
    if (!context || !context.contextAnswerContext) return;
    let collect = [];
    for (let i = 0; i < context.contextAnswerContext.length; i++) {
        const answer = context.contextAnswerContext[i];
        if (answerContext) {
            if (answer.questionID === questionID && answer.answerContext === answerContext) {
                collect.push(answer);
            }
        } else {
            if (answer.questionID === questionID) {
                collect.push(answer);
            }
        }
    }
    return collect;
};
export const getAnswerValue = (answer) => {
    if (!answer) return;
    switch (answer.answerTypeID) {
        case 2: //string
            return {
                contextID: answer.contextID,
                ID: answer.ID,
                value: answer.answerString,
                answerTypeID: answer.answerTypeID,
                answerDisplay: answer.answerDisplay,
                questionID: answer.questionID
            }
        case 3: //bool
            return {
                contextID: answer.contextID,
                ID: answer.ID,
                value: answer.answerBool,
                answerTypeID: answer.answerTypeID,
                answerDisplay: answer.answerDisplay,
                questionID: answer.questionID
            }
        case 4: //int
            return {
                contextID: answer.contextID,
                ID: answer.ID,
                value: answer.answerInt,
                answerTypeID: answer.answerTypeID,
                answerDisplay: answer.answerDisplay,
                questionID: answer.questionID
            }
        case 5: //float
            return {
                contextID: answer.contextID,
                ID: answer.ID,
                value: answer.answerFloat,
                answerTypeID: answer.answerTypeID,
                answerDisplay: answer.answerDisplay,
                questionID: answer.questionID
            }
        case 6: //date
            return {
                contextID: answer.contextID,
                ID: answer.ID,
                value: answer.answerDate,
                answerTypeID: answer.answerTypeID,
                answerDisplay: answer.answerDisplay,
                questionID: answer.questionID
            }
        case 10: //json
            return {
                contextID: answer.contextID,
                ID: answer.ID,
                value: answer.answerJson,
                answerTypeID: answer.answerTypeID,
                answerDisplay: answer.answerDisplay,
                questionID: answer.questionID
            }
        case 7: //select
            return {
                contextID: answer.contextID,
                ID: answer.ID,
                value: answer.answerID,
                answerObject: answer.answerObject,
                answerDisplay: answer.answerDisplay,
                answerTypeID: answer.answerTypeID,
                questionID: answer.questionID
            }
        case 8: //multiselect
            return {
                contextID: answer.contextID,
                ID: answer.ID,
                value: answer.answerID,
                answerObject: answer.answerObject,
                answerDisplay: answer.answerDisplay,
                answerTypeID: answer.answerTypeID,
                questionID: answer.questionID
            }
        case 9: //object
            return {
                contextID: answer.contextID,
                ID: answer.ID,
                value: answer.answerID,
                answerContext: answer.answerContext,
                answerObject: answer.answerObject,
                answerDisplay: answer.answerDisplay,
                answerTypeID: answer.answerTypeID,
                questionID: answer.questionID
            }
        default: // void
            return {
                contextID: answer.contextID,
                ID: answer.ID,
                value: answer.answerString,
                answerTypeID: answer.answerTypeID,
                answerDisplay: answer.answerDisplay,
                questionID: answer.questionID
            }
    }
};
export const getAnswersFromContext = (context, question) => {
    if (!context || !context.contextAnswerContext) {
        return [];
    }
    let answers = [];
    for (let i = 0; i < context.contextAnswerContext.length; i++) {
        const answer = context.contextAnswerContext[i];
        if (answer.questionID === question.ID) {
            answers.push(getAnswerValue(answer));
        }
    }
    return answers;
};
export const getObjectAnswerFromContext = (context, question, subquestion) => {
    const aswersFromContext = getAnswersFromContext(context, question);
    if (aswersFromContext) {
        let v = aswersFromContext.filter(e => e.answerContext === subquestion.ID);
        if (v) {
            return v;
        }
    }
    return;
};
export const makeAnswer = (context, question, value, display, subquestion, objectName) => {
    let o = {
        answerTypeID: question.answerTypeID,
        questionID: question.ID,
        contextID: context.ID
        // ID
    };
    switch (question.answerTypeID) {
        case 2: //string
            o["answerString"] = value;
            break;
        case 3: //bool
            o["answerBool"] = value;
            break;
        case 4: //int
            o["answerInt"] = value;
            break;
        case 5: //float
            o["answerFloat"] = value;
            break;
        case 6: //date
            o["answerDate"] = value;
            break;
        case 10: //json
            o["answerJson"] = value;
            break;
        case 7: //select
            o["answerID"] = value;
            o["answerObject"] = question.objectName;
            o["answerDisplay"] = display;
            break;
        case 8: //multiselect
            o["answerID"] = value;
            o["answerObject"] = question.objectName;
            o["answerDisplay"] = display;
            break;
        case 9: //object
            // o["answerContextTypeID"] = subquestion.answerTypeID;
            switch (subquestion.answerTypeID) {
                case 2: //string
                    o["answerString"] = value;
                    break;
                case 3: //bool
                    o["answerBool"] = value;
                    break;
                case 4: //int
                    o["answerInt"] = value;
                    break;
                case 5: //float
                    o["answerFloat"] = value;
                    break;
                case 6: //date
                    o["answerDate"] = value;
                    break;
                case 10: //json
                    o["answerJson"] = value;
                    break;
                case 7: //select
                    o["answerID"] = value;
                    break;
                case 8: //multiselect
                    o["answerID"] = value;
                    break;
                case 9: //object
                    o["answerID"] = value;
                    o["answerObject"] = objectName; //question.objectName;
                    break;
                default: // void
                    o["answerID"] = value;
                    break;
            }
            o["answerDisplay"] = display;
            o["answerContext"] = subquestion.ID; // идентификатор вопроса в группе
            o["answerName"] = subquestion.name || subquestion.title; // Наименование вопроса в группе
            break;
        default: // void
            o["answerString"] = value;
            break;
    }
    return o;
};
export const detailAnswer = (auth, contextAnswer, callback) => {
    if (contextAnswer && contextAnswer.answerObject) {
        READWITH(auth, contextAnswer.answerObject,
            [
                QueryDetail("model"),
                QueryParam("w-ID", contextAnswer.value)
            ],
            (res) => callback(_.get(res, "data[0]")),
            errorCatch
        );
    }
};
export const answersClearAll = (auth, context, onChange, { lock, unlock }) => {
    if (lock) lock();
    GET(auth, `/api/fsm/context/answer/clear/context/${context.ID}`, (res) => {
        if (onChange) {
            onChange(res.data);
        }
        if (unlock) unlock();
    }, (err) => errorCatch(err, unlock));
};
export const answersClear = (auth, context, question, onChange, { lock, unlock }) => {
    if (lock) lock();
    GET(auth, `/api/fsm/context/answer/clear/context/${context.ID}/question/${question.ID}`, (res) => {
        if (onChange) {
            onChange(res.data);
        }
        if (unlock) unlock();
    }, (err) => errorCatch(err, unlock));
};
export const answersDelete = (auth, context, question, answer, onChange, { lock, unlock }) => {
    if (lock) lock();
    POST(auth, "/api/fsm/context/answer/delete", answer, (res) => {
        if (onChange) {
            onChange(res.data);
        }
        if (unlock) unlock();
    }, (err) => errorCatch(err, unlock));
};
export const answersAppend = (auth, context, question, answer, onChange, { lock, unlock }) => {
    if (lock) lock();
    POST(auth, "/api/fsm/context/answer/add", answer, (res) => {
        if (onChange) {
            onChange(res.data);
        }
        if (unlock) unlock();
    }, (err) => errorCatch(err, unlock));
};
export const funcClient = (auth, context, serviceID, fsmFunctionID, question, answer, onChange, { lock, unlock }) => {
    if (lock) lock();
    POST(auth, `/api/fsm/func/client/${serviceID}/${fsmFunctionID}`, answer, ({ data }) => {
        if (onChange) {
            onChange(data);
        }
        if (unlock) unlock();
    }, (err) => errorCatch(err, unlock));
};
//------------------------------------------------------------------------------
export const convertEventResult = (data) => {
    if (!data || !data.length) {
        return
    }

    // let meropriyatie = data[0]?.protocolDancer?.protocol?.judgeBunch?.bunch?.tour?.kategoriiUchastnikovNaMeropriyatiyakh?.meropriyatie;
    // if (!meropriyatie) {
    // 	console.error("Не найдено мероприятие в результатах");
    // }
    let dancer = data[0]?.protocolDancer?.dancerBunch?.dancerTour?.dancerEvent.user;
    if (!dancer) {
        console.error("Не найден танцор в результатах");
    }

    let kategorii = fillKategorii(data);

    let result = {
        // meropriyatie: meropriyatie,
        dancer: dancer,
        kategorii: kategorii,
    }

    return result;
}

const fillKategorii = (data) => {
    let result = {
        kategoriiMap: {},
        kategorii: [],
    }

    for (let i = 0; i < data.length; i++) {
        let protocolDancerParams = data[i];

        let tour = protocolDancerParams?.protocolDancer?.protocol?.judgeBunch?.bunch?.tour;

        //Убираем лишнии criterionLevel из критериев которые не соответствуют шаблону в туре
        //criterionLevel используется для расстановки критериев по приоритету
        if (protocolDancerParams?.criterionParams?.criterion?.criterionLevel?.length) {
            protocolDancerParams.criterionParams.criterion.criterionLevel = protocolDancerParams.criterionParams.criterion.criterionLevel.filter((item) => item.templateID === tour.templateCloneID)
        }

        //Категория
        let kategoriya = tour?.kategoriiUchastnikovNaMeropriyatiyakh;
        let kategoriyaItem = result.kategoriiMap[kategoriya.ID] || {
            kategoriyaUchastnikovNaMeropriyatii: kategoriya,
            toursMap: {},
            tours: [],
            dancerEvent: protocolDancerParams?.protocolDancer?.dancerBunch?.dancerTour?.dancerEvent,
        };

        //Тур
        let tourItem = kategoriyaItem.toursMap[tour.ID] || {
            tour: tour,
            criterionViewMap: {},
            criterionView: [],
            judgeViewMap: {},
            judgeView: [],
            plus: 0,
            minus: 0,
        }

        //-------------------------по критериям-------------------------
        //Критерий
        let criterion = protocolDancerParams?.criterionParams?.criterion
        let criterionItem = tourItem.criterionViewMap[criterion.ID] || {
            criterion: criterion,
            criterionParamsMap: {},
            criterionParams: [],
            plus: 0,
            minus: 0,
        }

        //Параметры критериев
        let criterionParams = protocolDancerParams?.criterionParams
        let criterionParamsItem = criterionItem.criterionParamsMap[criterionParams.ID] || {
            criterionParams: criterionParams,
            protocolDancerParams: [],
            plus: 0,
            minus: 0,
        }
        criterionParamsItem.protocolDancerParams.push(protocolDancerParams);

        //-------------------------по судьям-------------------------
        //Судья
        let judge = protocolDancerParams?.protocolDancer?.protocol?.judgeBunch?.user;
        let judgeItem = tourItem.judgeViewMap[judge.ID] || {
            judge: judge,
            criterionMap: {},
            criterions: [],
            plus: 0,
            minus: 0,
        }

        //Параметры критериев
        let criterionJudgeViewMapItem = judgeItem.criterionMap[criterion.ID] || {
            criterion: criterion,
            protocolDancerParams: [],
            plus: 0,
            minus: 0,
        }
        criterionJudgeViewMapItem.protocolDancerParams.push(protocolDancerParams);

        judgeItem.criterionMap[criterion.ID] = criterionJudgeViewMapItem;
        tourItem.judgeViewMap[judge.ID] = judgeItem;
        criterionItem.criterionParamsMap[criterionParams.ID] = criterionParamsItem
        tourItem.criterionViewMap[criterion.ID] = criterionItem;
        kategoriyaItem.toursMap[tour.ID] = tourItem;
        result.kategoriiMap[kategoriya.ID] = kategoriyaItem;
    }

    result = sortKategorii(result)

    return result;
}

const sortKategorii = (data) => {
    //Заполняем массив категорий
    for (const kategoriyaID in data.kategoriiMap) {
        if (Object.hasOwnProperty.call(data.kategoriiMap, kategoriyaID)) {
            let kategoriya = data.kategoriiMap[kategoriyaID];
            data.kategorii.push(kategoriya);

            //Заполняем массив туров
            for (const tourID in kategoriya?.toursMap) {
                if (Object.hasOwnProperty.call(kategoriya.toursMap, tourID)) {
                    let tour = kategoriya.toursMap[tourID];
                    kategoriya.tours.push(tour);

                    //Заполняем массив критериев
                    //-------------------------по критериям-------------------------
                    for (const criterionID in tour?.criterionViewMap) {
                        if (Object.hasOwnProperty.call(tour.criterionViewMap, criterionID)) {
                            let criterionView = tour.criterionViewMap[criterionID];
                            tour.criterionView.push(criterionView);

                            //Заполняем массив параметров
                            for (const criterionParamsID in criterionView.criterionParamsMap) {
                                if (Object.hasOwnProperty.call(criterionView.criterionParamsMap, criterionParamsID)) {
                                    let criterionParams = criterionView.criterionParamsMap[criterionParamsID];

                                    //Сортируем судей
                                    criterionParams.protocolDancerParams = criterionParams?.protocolDancerParams?.sort((a, b) => {
                                        let judgeA = a.protocolDancer?.protocol?.judgeBunch?.user
                                        let judgeB = a.protocolDancer?.protocol?.judgeBunch?.user
                                        if (judgeA.lastname?.toLowerCase() > judgeB.lastname?.toLowerCase()) {
                                            return 1
                                        }
                                        if (judgeA.lastname?.toLowerCase() < judgeB.lastname?.toLowerCase()) {
                                            return -1
                                        }
                                        if (judgeA.firstname?.toLowerCase() > judgeB.firstname?.toLowerCase()) {
                                            return 1
                                        }
                                        if (judgeA.firstname?.toLowerCase() < judgeB.firstname?.toLowerCase()) {
                                            return -1
                                        }
                                        return 0
                                    })

                                    //Подсчет оценок
                                    if (tour?.tour?.protocolValueTypeID === 1) {
                                        //Плюсы/минусы
                                        if (tour?.tour?.algoritmRaschetaID === 2) {
                                            let plus = criterionParams?.protocolDancerParams?.reduce((sum, item) => {
                                                let weight = item.criterionParams.weight || 1
                                                if ((item?.protocolDancer?.protocol?.genderID == 1 && tour?.tour?.raspredSudeiPoKriteriyamMID == 3) ||
                                                    (item?.protocolDancer?.protocol?.genderID == 2 && tour?.tour?.raspredSudeiPoKriteriyamWID == 3)) {
                                                    weight = 1
                                                }

                                                if (!item.value || (item.value > -0.000001 && item.value < 0.000001)) {
                                                    sum += (2 * weight)
                                                } else if (item.value < 0) {
                                                    sum += weight
                                                } else if (item.value > 0) {
                                                    sum += (3 * weight)
                                                }
                                                return sum;
                                            }, 0)
                                            criterionParams.plus = plus
                                            criterionView.plus += plus
                                            tour.plus += plus
                                        } else {
                                            let plus = criterionParams?.protocolDancerParams?.reduce((sum, item) => {
                                                let weight = item.criterionParams.weight || 1
                                                if ((item?.protocolDancer?.protocol?.genderID == 1 && tour?.tour?.raspredSudeiPoKriteriyamMID == 3) ||
                                                    (item?.protocolDancer?.protocol?.genderID == 2 && tour?.tour?.raspredSudeiPoKriteriyamWID == 3)) {
                                                    weight = 1
                                                }

                                                if (item.value && item.value > 0)
                                                    sum += (item.value * weight)
                                                return sum;
                                            }, 0)
                                            criterionParams.plus = plus
                                            criterionView.plus += plus
                                            tour.plus += plus

                                            let minus = criterionParams?.protocolDancerParams?.reduce((sum, item) => {
                                                let weight = item.criterionParams.weight || 1
                                                if ((item?.protocolDancer?.protocol?.genderID == 1 && tour?.tour?.raspredSudeiPoKriteriyamMID == 3) ||
                                                    (item?.protocolDancer?.protocol?.genderID == 2 && tour?.tour?.raspredSudeiPoKriteriyamWID == 3)) {
                                                    weight = 1
                                                }

                                                if (item.value && item.value < 0)
                                                    sum += Math.abs(item.value * weight)
                                                return sum;
                                            }, 0)
                                            criterionParams.minus = minus
                                            criterionView.minus += minus
                                            tour.minus += minus
                                        }
                                    } else {
                                        //Баллы
                                        let plus = criterionParams?.protocolDancerParams?.reduce((sum, item) => {
                                            let weight = item.criterionParams.weight || 1
                                            if ((item?.protocolDancer?.protocol?.genderID == 1 && tour?.tour?.raspredSudeiPoKriteriyamMID == 3) ||
                                                (item?.protocolDancer?.protocol?.genderID == 2 && tour?.tour?.raspredSudeiPoKriteriyamWID == 3)) {
                                                weight = 1
                                            }

                                            if (item.value)
                                                sum += (item.value * weight)
                                            return sum;
                                        }, 0)
                                        criterionParams.plus = plus
                                        criterionView.plus += plus
                                        tour.plus += plus
                                    }

                                    criterionView.criterionParams.push(criterionParams)
                                }
                            }

                            //Сортируем параметры
                            criterionView.criterionParams = criterionView?.criterionParams?.sort((a, b) => a.criterionParams.priorityInCriterion - b.criterionParams.priorityInCriterion)
                        }
                    }
                    //Сортируем criterionView
                    tour.criterionView = tour?.criterionView?.sort((a, b) => a.criterion.criterionLevel[0].priority - b.criterion.criterionLevel[0].priority)

                    //Заполняем массив судей
                    //-------------------------по судьям-------------------------
                    for (const judgeID in tour?.judgeViewMap) {
                        if (Object.hasOwnProperty.call(tour.judgeViewMap, judgeID)) {
                            let judgeView = tour.judgeViewMap[judgeID];
                            tour.judgeView.push(judgeView);

                            //Заполняем массив критериев
                            for (const criterionID in judgeView.criterionMap) {
                                if (Object.hasOwnProperty.call(judgeView.criterionMap, criterionID)) {
                                    let criterions = judgeView.criterionMap[criterionID];
                                    judgeView.criterions.push(criterions)

                                    //Подсчет оценок
                                    if (tour?.tour?.protocolValueTypeID === 1) {
                                        //Плюсы/минусы
                                        if (tour?.tour?.algoritmRaschetaID === 2) {
                                            let plus = criterions?.protocolDancerParams?.reduce((sum, item) => {
                                                let weight = item.criterionParams.weight || 1
                                                if ((item?.protocolDancer?.protocol?.genderID == 1 && tour?.tour?.raspredSudeiPoKriteriyamMID == 3) ||
                                                    (item?.protocolDancer?.protocol?.genderID == 2 && tour?.tour?.raspredSudeiPoKriteriyamWID == 3)) {
                                                    weight = 1
                                                }

                                                if (!item.value || (item.value > -0.000001 && item.value < 0.000001)) {
                                                    sum += (2 * weight)
                                                } else if (item.value < 0) {
                                                    sum += weight
                                                } else if (item.value > 0) {
                                                    sum += (3 * weight)
                                                }
                                                return sum;
                                            }, 0)
                                            criterions.plus += plus
                                            judgeView.plus += plus
                                        } else {
                                            let plus = criterions?.protocolDancerParams?.reduce((sum, item) => {
                                                let weight = item.criterionParams.weight || 1
                                                if ((item?.protocolDancer?.protocol?.genderID == 1 && tour?.tour?.raspredSudeiPoKriteriyamMID == 3) ||
                                                    (item?.protocolDancer?.protocol?.genderID == 2 && tour?.tour?.raspredSudeiPoKriteriyamWID == 3)) {
                                                    weight = 1
                                                }

                                                if (item.value && item.value > 0)
                                                    sum += (item.value * weight)
                                                return sum;
                                            }, 0)
                                            criterions.plus += plus
                                            judgeView.plus += plus
                                            let minus = criterions?.protocolDancerParams?.reduce((sum, item) => {
                                                let weight = item.criterionParams.weight || 1
                                                if ((item?.protocolDancer?.protocol?.genderID == 1 && tour?.tour?.raspredSudeiPoKriteriyamMID == 3) ||
                                                    (item?.protocolDancer?.protocol?.genderID == 2 && tour?.tour?.raspredSudeiPoKriteriyamWID == 3)) {
                                                    weight = 1
                                                }

                                                if (item.value && item.value < 0)
                                                    sum += Math.abs(item.value * weight)
                                                return sum;
                                            }, 0)
                                            criterions.minus = minus
                                            judgeView.minus += minus
                                        }
                                    } else {
                                        //Баллы
                                        let plus = criterions?.protocolDancerParams?.reduce((sum, item) => {
                                            let weight = item.criterionParams.weight || 1
                                            if ((item?.protocolDancer?.protocol?.genderID == 1 && tour?.tour?.raspredSudeiPoKriteriyamMID == 3) ||
                                                (item?.protocolDancer?.protocol?.genderID == 2 && tour?.tour?.raspredSudeiPoKriteriyamWID == 3)) {
                                                weight = 1
                                            }

                                            if (item.value)
                                                sum += (item.value * weight)
                                            return sum;
                                        }, 0)
                                        criterions.plus += plus
                                        judgeView.plus += plus
                                    }

                                    //Сортируем параметры
                                    criterions.protocolDancerParams = criterions?.protocolDancerParams?.sort((a, b) => a.criterionParams.priorityInCriterion - b.criterionParams.priorityInCriterion)
                                }
                            }

                            //Сортируем критерии
                            judgeView.criterions = judgeView?.criterions?.sort((a, b) => a.criterion.criterionLevel[0].priority - b.criterion.criterionLevel[0].priority)
                        }
                    }

                    //Сортируем judgeView
                    tour.judgeView = tour?.judgeView?.sort((a, b) => {
                        if (a.judge?.lastname?.toLowerCase() > b.judge?.lastname?.toLowerCase()) {
                            return 1
                        }
                        if (a.judge?.lastname?.toLowerCase() < b.judge?.lastname?.toLowerCase()) {
                            return -1
                        }
                        if (a.judge?.firstname?.toLowerCase() > b.judge?.firstname?.toLowerCase()) {
                            return 1
                        }
                        if (a.judge?.firstname?.toLowerCase() < b.judge?.firstname?.toLowerCase()) {
                            return -1
                        }
                        return 0
                    })
                }
            }

            //Сортируем туры
            kategoriya.tours = kategoriya?.tours?.sort((a, b) => a.tour.number - b.tour.number)
        }
    }

    //Сортируем категории
    data.kategorii = data?.kategorii?.sort((a, b) => a.kategoriyaUchastnikovNaMeropriyatii.sort - b.kategoriyaUchastnikovNaMeropriyatii.sort)

    return data;
}
//------------------------------------------------------------------------------
function Buffer(_buffer) {
    const buffer = _buffer
    const length = _buffer.length;

    // Функция возвращающая часть данных
    const cslice = (offset, length) => {
        var x = new Uint8Array(length);
        for (var i = offset, j = 0; i < offset + length && j < length; i++, j++) {
            x[j] = buffer[i];
        }
        return x;
    }
    const slice = (offset, length) => {
        return Buffer(cslice(offset, length));
    }

    // Возвращаем определенный байт
    const byteAt = (i) => {
        return buffer[i] & 0xFF;
    }
    const cbyteAt = (i) => {
        return buffer[i];
    }
    // Возращаем ASCII символ
    const charAt = (i) => {
        var code = byteAt(i);
        if (code == 0) return " ";
        // if (code < 32) return "?";
        return String.fromCharCode(code);
    }
    // Возращаем ASCII строку
    const stringAt = (offset, length) => {
        var str = [];
        for (var i = offset, j = 0; i < offset + length; i++, j++) {
            str[j] = charAt(i);
        }
        return str.join("").trim();
    }
    const string0x00 = (offset) => {
        var str = [];
        for (var i = offset, j = 0; i < offset + length; i++, j++) {
            if (cbyteAt(i) == 0x00) break;
            str[j] = charAt(i);
        }
        return str.join("").trim();
    }
    // Возращаем ASCII для всего массива данных
    const toString = () => {
        // https://mutagen-specs.readthedocs.io/en/latest/id3/id3v2.4.0-structure.html

        // 0x00 ISO-8859-1[ISO-8859-1].Завершается на 0x00.
        // 0x01 UTF-16[UTF-16] в кодировке Юникод[UNICODE] с BOM.Все
        // строки в одном кадре ДОЛЖНЫ иметь одинаковый порядок байтов.
        // Завершается на 0x00 0x00.
        // 0x02 UTF-16BE[UTF-16] в кодировке Юникод[UNICODE] без BOM.
        // Завершается символом 0x00 0x00.
        // 0x03 UTF-8[UTF-8] в кодировке Юникод[UNICODE].Завершается символом 0x00.
        if (byteAt(0) == 0x00) {
            return stringAt(1, length - 1)
            // return new TextDecoder("ISO-8859-1").decode(cslice(1, length - 1))
        } else if (byteAt(0) == 0x01) {
            // if(byteAt(0) == 0xFF && byteAt(1) == 0xFE)
            // ÿþ is 0xFF 0xFE in UTF-8; this is the byte order mark in UTF-16
            return new TextDecoder("UTF-16LE").decode(cslice(1, length - 1))
        } else if (byteAt(0) == 0x02) {
            return new TextDecoder("UTF-16BE").decode(cslice(1, length - 1))
        } else if (byteAt(0) == 0x03) {
            return new TextDecoder("UTF-8").decode(cslice(1, length - 1))
        }
        return stringAt(0, length);
    }

    const toHex = () => {
        return buffer.toHex()
    }
    return {
        length,
        cslice,
        slice,
        byteAt,
        cbyteAt,
        charAt,
        stringAt,
        string0x00,
        toString,
        toHex
    }
}

async function fileAsArrayBuffer(file) {
    let data = await new Promise((resolve) => {
        let fileReader = new FileReader();
        fileReader.onload = (e) => {
            if (e.target.readyState == FileReader.DONE) {
                console.log(e);

                resolve(e.target.result)
            }
        };
        fileReader.readAsArrayBuffer(file);
    });
    return data;
}
function UnSynchsafeInt(buffer) {
    var value = 0;
    for (var i = 0, length = buffer.length; i < length; i++) {
        value += (buffer.byteAt(i) & 0x7F) * Math.pow(Math.pow(2, 7), length - i - 1);
    }
    return value;
}
function string2Bin(str) {
    var result = [];
    for (var i = 0; i < str.length; i++) {
        result.push(str.charCodeAt(i));
    }
    return result;
}
function bin2String(array) {
    return String.fromCharCode.apply(String, array);
}
function binaryToDataURL(inputArray, type) {
    var uri = undefined
    try {
        var base64 = btoa(String.fromCharCode.apply(null, inputArray)); // Convert byte array to Base64
        uri = 'data:' + type + ';base64,' + base64; // Prepend the data URL scheme   
    } catch (error) {
        console.log(error);
    }
    return uri;
}
// Будем читать первый выбранный файл
export const validFramesIds = {
    "BUF": "Рекомендуемый размер буфера", //"Recommended buffer size",
    "CNT": "Счетчик воспроизведения", //"Play counter",
    "COM": "Комментарии", //"Comments",
    "CRA": "Шифрование звука", //"Audio encryption",
    "CRM": "Зашифрованный мета-кадр", //"Encrypted meta frame",
    "ETC": "Временные коды событий", //"Event timing codes",
    "EQU": "Выравнивание", //"Equalization",
    "GEO": "Общий инкапсулированный объект", //"General encapsulated object",
    "IPL": "Список задействованных лиц", //"Involved people list",
    "LNK": "Связанная информация", //"Linked information",
    "MCI": "Идентификатор музыкального компакт-диска", //"Music CD Identifier",
    "MLL": "Таблица поиска местоположения в формате MPEG", //"MPEG location lookup table",
    "PIC": "Прикрепленная картинка", //"Attached picture",
    "POP": "Популяризатор", //"Popularimeter",
    "REV": "Реверберация", //"Reverb",
    "RVA": "Относительная регулировка громкости", //"Relative volume adjustment",
    "SLT": "Синхронизированные тексты песен/текст", //"Synchronized lyric/text",
    "STC": "Синхронизированные темпокоды", //"Synced tempo codes",
    "TAL": "Название альбома/фильма/шоу", //"Album/Movie/Show title",
    "TBP": "Количество ударов в минуту", //"BPM (Beats Per Minute)",
    "TCM": "Композитор", //"Composer",
    "TCO": "Тип контента", //"Content type",
    "TCR": "Сообщение об авторских правах", //"Copyright message",
    "TDA": "Дата", //"Date",
    "TDY": "Задержка воспроизведения", //"Playlist delay",
    "TEN": "Кодируется по", //"Encoded by",
    "TFT": "Тип файла", //"File type",
    "TIM": "Время", //"Time",
    "TKE": "Начальная клавиша", //"Initial key",
    "TLA": "Язык(ы)", //"Language(s)",
    "TLE": "Длина", //"Length",
    "TMT": "Тип носителя", //"Media type",
    "TOA": "Автор(ы) оригинального альбома/исполнительницы", //"Original artist(s)/performer(s)",
    "TOF": "Оригинальное название файла", //"Original filename",
    "TOL": "Автор(ы) оригинального текста", //"Original Lyricist(s)/text writer(s)",
    "TOR": "Оригинальный год выпуска", //"Original release year",
    "TOT": "Оригинальное название альбома/фильма/шоу", //"Original album/Movie/Show title",
    "TP1": "Ведущий артист(-ы)/Ведущая исполнительница(-ы)/Солист(-ы)/Исполнительская группа", //"Lead artist(s)/Lead performer(s)/Soloist(s)/Performing group",
    "TP2": "Группа/Оркестр/Аккомпанемент", //"Band/Orchestra/Accompaniment",
    "TP3": "Доработка дирижера/исполнителя", //"Conductor/Performer refinement",
    "TP4": "Интерпретация, ремикширование или иное изменение", //"Interpreted, remixed, or otherwise modified by",
    "TPA": "Часть набора", //"Part of a set",
    "TPB": "Издатель", //"Publisher",
    "TRC": "ISRC (Международный стандартный код записи)", //"ISRC (International Standard Recording Code)",
    "TRD": "Даты записи", //"Recording dates",
    "TRK": "Номер трека/позиция в наборе", //"Track number/Position in set",
    "TSI": "Размер", //"Size",
    "TSS": "Программное/аппаратное обеспечение и настройки, используемые для кодирования", //"Software/hardware and settings used for encoding",
    "TT1": "Описание группы контента", //"Content group description",
    "TT2": "Название песни/Описание контента", //"Title/Songname/Content description",
    "TT3": "Уточнение субтитров/описания", //"Subtitle/Description refinement",
    "TXT": "Автор текста", //"Lyricist/text writer",
    "TXX": "Пользовательская текстовая информационная рамка", //"User defined text information frame",
    "TYE": "Год выпуска", //"Year",
    "UFI": "Уникальный идентификатор файла", //"Unique file identifier",
    "ULT": "Расшифровка текста", //"Unsychronized lyric/text transcription",
    "WAF": "Официальная веб-страница аудиофайла", //"Official audio file webpage",
    "WAR": "Официальная веб-страница исполнителя", //"Official artist/performer webpage",
    "WAS": "Официальная веб-страница аудиоисточника", //"Official audio source webpage",
    "WCM": "Коммерческая информация", //"Commercial information",
    "WCP": "Информация об авторских правах/Юридическая информация", //"Copyright/Legal information",
    "WPB": "Официальная веб-страница издательства", //"Publishers official webpage",
    "WXX": "Пользовательская рамка URL-ссылок", //"User defined URL link frame",
    "AENC": "Шифрование аудио", //"Audio encryption",
    "APIC": "Прикрепленное изображение", //"Attached picture",
    "ASPI": "Индекс точки поиска аудио", //"Audio seek point index",
    "CHAP": "Глава", //"Chapter",
    "CTOC": "Оглавление", //"Table of contents",
    "COMM": "Комментарии", //"Comments",
    "COMR": "Рекламный ролик", //"Commercial frame",
    "ENCR": "Регистрация метода шифрования", //"Encryption method registration",
    "EQU2": "Выравнивание (2)", //"Equalisation (2)",
    "EQUA": "Выравнивание", //"Equalization",
    "ETCO": "Временные коды событий", //"Event timing codes",
    "GEOB": "Общий инкапсулированный объект", //"General encapsulated object",
    "GRID": "Регистрация для идентификации группы", //"Group identification registration",
    "IPLS": "Список вовлеченных людей", //"Involved people list",
    "LINK": "Связанная информация", //"Linked information",
    "MCDI": "Идентификатор музыкального компакт-диска", //"Music CD identifier",
    "MLLT": "Таблица поиска местоположения в формате MPEG", //"MPEG location lookup table",
    "OWNE": "Фрейм владельца", //"Ownership frame",
    "PRIV": "Личный фрейм", //"Private frame",
    "PCNT": "Счетчик воспроизведения", //"Play counter",
    "POPM": "Популяризатор", //"Popularimeter",
    "POSS": "Синхронизация положения кадра", //"Position synchronisation frame",
    "RBUF": "Рекомендуемый размер буфера", //"Recommended buffer size",
    "RVA2": "Относительная регулировка громкости (2)", //"Relative volume adjustment (2)",
    "RVAD": "Относительная регулировка громкости", //"Relative volume adjustment",
    "RVRB": "Реверберация", //"Reverb",
    "SEEK": "Поиск кадра", //"Seek frame",
    "SYLT": "Синхронизированная лирика/текст", //"Synchronized lyric/text",
    "SYTC": "Синхронизированные темпокоды", //"Synchronized tempo codes",
    "TALB": "Название альбома/фильма/шоу", //"Album/Movie/Show title",
    "TBPM": "Количество ударов в минуту", //"BPM (beats per minute)",
    "TCOM": "Композитор", //"Composer",
    "TCON": "Тип контента", //"Content type",
    "TCOP": "Сообщение об авторских правах", //"Copyright message",
    "TDAT": "Дата", //"Date",
    "TDLY": "Задержка воспроизведения", //"Playlist delay",
    "TDRC": "Время записи", //"Recording time",
    "TDRL": "Время выхода", //"Release time",
    "TDTG": "Время добавления тегов", //"Tagging time",
    "TENC": "Закодировано", //"Encoded by",
    "TEXT": "Автор текста", //"Lyricist/Text writer",
    "TFLT": "Тип файла", //"File type",
    "TIME": "Время", //"Time",
    "TIPL": "Список участников", //"Involved people list",
    "TIT1": "Описание группы контента", //"Content group description",
    "TIT2": "Название/песня/описание контента", //"Title/songname/content description",
    "TIT3": "Уточнение субтитров/описания", //"Subtitle/Description refinement",
    "TKEY": "Начальный ключ", //"Initial key",
    "TLAN": "Язык(ы)", //"Language(s)",
    "TLEN": "Продолжительность", //"Length",
    "TMCL": "Список авторов песен", //"Musician credits list",
    "TMED": "Тип носителя", //"Media type",
    "TMOO": "Настроение", //"Mood",
    "TOAL": "Оригинальное название альбома/фильма/шоу", //"Original album/movie/show title",
    "TOFN": "Оригинальное имя файла", //"Original filename",
    "TOLY": "Автор(ы) оригинальных текстов", //"Original lyricist(s)/text writer(s)",
    "TOPE": "Оригинальный исполнитель(-ы)", //"Original artist(s)/performer(s)",
    "TORY": "Год выпуска оригинала", //"Original release year",
    "TOWN": "Владелец файла/лицензиат", //"File owner/licensee",
    "TPE1": "Ведущий исполнитель(-ы)/Солистка(-ы)", //"Lead performer(s)/Soloist(s)",
    "TPE2": "Группа/оркестр/аккомпанемент", //"Band/orchestra/accompaniment",
    "TPE3": "Уточнение дирижера/исполнителя", //"Conductor/performer refinement",
    "TPE4": "Интерпретировано, ремикшировано или иным образом изменено", //"Interpreted, remixed, or otherwise modified by",
    "TPOS": "Частью набора", //"Part of a set",
    "TPRO": "Уведомление о выпуске", //"Produced notice",
    "TPUB": "Издатель", //"Publisher",
    "TRCK": "Номер трека/позиция в наборе", //"Track number/Position in set",
    "TRDA": "Даты записи", //"Recording dates",
    "TRSN": "Название интернет-радиостанции", //"Internet radio station name",
    "TRSO": "Владелец интернет-радиостанции", //"Internet radio station owner",
    "TSOA": "Порядок сортировки альбомов", //"Album sort order",
    "TSOP": "Порядок сортировки исполнителей", //"Performer sort order",
    "TSOT": "Порядок сортировки названий", //"Title sort order",
    "TSIZ": "Размер", //"Size",
    "TSRC": "ISRC (международный стандартный код записи)", //"ISRC (international standard recording code)",
    "TSSE": "Программное обеспечение/аппаратные средства и настройки, используемые для кодирования", //"Software/Hardware and settings used for encoding",
    "TSST": "Установка субтитров", //"Set subtitle",
    "TYER": "Год выпуска", //"Year",
    "TXXX": "Текстовая информационная рамка, определяемая пользователем", //"User defined text information frame",
    "UFID": "Уникальный идентификатор файла", //"Unique file identifier",
    "USER": "Условия использования", //"Terms of use",
    "USLT": "Непсихронизированная лирика/транскрипция текста", //"Unsychronized lyric/text transcription",
    "WCOM": "Коммерческая информация", //"Commercial information",
    "WCOP": "Информация об авторских правах/Юридическая информация", //"Copyright/Legal information",
    "WOAF": "Официальная веб-страница аудиофайла", //"Official audio file webpage",
    "WOAR": "Официальная веб-страница исполнителя", //"Official artist/performer webpage",
    "WOAS": "Официальная веб-страница аудиоисточника", //"Official audio source webpage",
    "WORS": "Официальная домашняя страница интернет-радиостанции", //"Official internet radio station homepage",
    "WPAY": "Оплата", //"Payment",
    "WPUB": "Официальная веб-страница издательства", //"Publishers official webpage",
    "WXXX": "Пользовательский URL-адрес", //"User defined URL link frame",
    "WFED": "Неизвестно", //"Unknown"
};
export async function ID3v2FromBlob(datafile, callback) {
    // Cюда будем сохранять ошибки
    let errors = [];
    // Версия тега
    let version = 'Unknown';
    // Флаги тега
    let flags = {
        isUnSynchronisation: false,
        hasExtendedHeader: false,
        isExperimental: false,
        hasFooter: false
    };
    // Размер тега в байтах. Размер не включает 10 байт заголовка и 10 байт футера (при наличии его)
    let size = 0;
    // Фреймы тега
    let frames = {};

    ///////////////////////////////////////////////////////////////////////
    var result = Buffer(new Uint8Array(datafile.slice(0, 10)));

    // Первые 3 байта должны содержать идентификатор тега
    if (result.stringAt(0, 3).toUpperCase() !== 'ID3') {
        errors.push('Ошибка: ID3v2 не найден!');
        // console.log(errors);
        // reject(errors);
        return;
    }
    // Четвертый и пятый байт содержат версию тега
    version = '2.' + result.byteAt(3) + '.' + result.byteAt(4);
    // console.log(version);

    // Пятый байт описывает флаги тега.
    // Я не буду останавливатся на них.
    flags.isUnSynchronisation = result.byteAt(5) & 128 ? true : false;
    flags.hasExtendedHeader = result.byteAt(5) & 64 ? true : false;
    flags.isExperimental = result.byteAt(5) & 32 ? true : false;
    flags.hasFooter = result.byteAt(5) & 16 ? true : false;

    // Для размера тега отведены 4 байта начиная с 7
    size = UnSynchsafeInt(result.slice(6, 4));

    // console.log(size, result.toHex(), result.slice(6, 4).toHex());

    if (size < 1) {
        errors.push('Ошибка: ID3v2 поврежден!');
        console.log(errors);
        // reject(errors);
        return;
    }

    result = Buffer(new Uint8Array(datafile.slice(0, size)));
    let cursor = 0;

    // Тег состоит из фреймов.
    // Фрейм в свою очередь имеет заголовок и значение фрейма.
    // Заголовок всегда занимает 10 байт.
    // В котором содержится параметры фрейма: ID (4 байта), размер (4 байта), флаги (2 байта)

    do {
        var frame = {};
        // Первые 4 байта занимает идентификатор фрейма
        var id = result.stringAt(cursor, 4);

        // Проверим если ИД поддреживается
        if (!validFramesIds[id]) {
            errors.push('Error: ID3v2 Фрейм не поддерживается (' + id + ')!');
            // let wsize = UnSynchsafeInt(result.slice(cursor + 4, 4));
            // console.log(wsize);
            cursor += 10;
        }
        else {
            function i2hex(i) {
                return ('0' + i.toString(16)).slice(-2);
            }
            let hex = (v) => Array.from(v).map(i2hex).join(' ');
            let UintBigEndian = (sizeArr) => ((sizeArr[sizeArr.length - 1]) |
                (sizeArr[sizeArr.length - 2] << 8) |
                (sizeArr[sizeArr.length - 3] << 16) |
                (sizeArr[sizeArr.length - 4] << 24));

            frame.id = id;
            var frame_size_Synchsafe = UnSynchsafeInt(result.slice(cursor + 4, 4));
            var frame_size_BigEndian = UintBigEndian(result.cslice(cursor + 4, 4))
            frame.size = frame_size_BigEndian;

            cursor += 10;

            if (frame.id == "APIC") {
                let data = result.slice(cursor, frame.size)
                let i = 0;
                while (true) {
                    if (0xFF == data.cbyteAt(i) && 0xD8 == data.cbyteAt(i + 1)) {
                        break;
                    }
                    i++;
                }
                let type = data.string0x00(1);
                let img = data.cslice(i, frame.size - i)

                frame.value = binaryToDataURL(img, type);
                frame.type = type
            } else {
                frame.value = result.slice(cursor, frame.size).toString();
                frame.data = result.cslice(cursor, frame.size)
            }

            cursor += frame.size;

            frames[id] = frame;
        }
    }
    while (cursor <= size);

    // Процесс завершен. Тег прочитан. Ура.
    // callback(self);
    // console.log(frames);
    if (callback) {
        callback(frames);
    }

    return frames
}
// =====================================================================================
// =====================================================================================
// HSL, HLS или HSI (от англ. hue, saturation, lightness (intensity)) — цветовая модель, 
// в которой цветовыми координатами являются тон, насыщенность и светлота. Следует отметить,
// что HSV и HSL — две разные цветовые модели (lightness — светлота, что отличается от 
// яркости).
// H — тон [0; 360]
// S — насыщенность [0; 1]
// L — светлота [0; 1]

// Changes the RGB/HEX temporarily to a HSL-Value, modifies that value
// and changes it back to RGB/HEX.
export function setLightness(rgb, value) {
    var hsl = rgbToHSL(rgb);
    hsl.l = value;
    return hslToRGB(hsl);
}
export function setSaturation(rgb, value) {
    var hsl = rgbToHSL(rgb);
    hsl.s = value;
    return hslToRGB(hsl);
}
export function setHue(rgb, value) {
    var hsl = rgbToHSL(rgb);
    hsl.h = value;
    return hslToRGB(hsl);
}

export function changeLightness(rgb, degree) {
    var hsl = rgbToHSL(rgb);
    hsl.l += degree;
    if (hsl.l > 1) {
        hsl.l -= 1;
    }
    else if (hsl.l < 0) {
        hsl.l += 1;
    }
    return hslToRGB(hsl);
}
export function changeSaturation(rgb, degree) {
    var hsl = rgbToHSL(rgb);
    hsl.s += degree;
    if (hsl.s > 1) {
        hsl.s -= 1;
    }
    else if (hsl.s < 0) {
        hsl.s += 1;
    }
    return hslToRGB(hsl);
}
export function changeHue(rgb, degree) {
    var hsl = rgbToHSL(rgb);
    hsl.h += degree;
    if (hsl.h > 360) {
        hsl.h -= 360;
    }
    else if (hsl.h < 0) {
        hsl.h += 360;
    }
    return hslToRGB(hsl);
}
// exepcts a string and returns an object
export function rgbToHSL(rgb) {
    // strip the leading # if it's there
    rgb = rgb.replace(/^\s*#|\s*$/g, '');
    // convert 3 char codes --> 6, e.g. `E0F` --> `EE00FF`
    if (rgb.length == 3) {
        rgb = rgb.replace(/(.)/g, '$1$1');
    }
    var r = parseInt(rgb.substr(0, 2), 16) / 255,
        g = parseInt(rgb.substr(2, 2), 16) / 255,
        b = parseInt(rgb.substr(4, 2), 16) / 255,
        cMax = Math.max(r, g, b),
        cMin = Math.min(r, g, b),
        delta = cMax - cMin,
        l = (cMax + cMin) / 2,
        h = 0,
        s = 0;
    if (delta == 0) {
        h = 0;
    }
    else if (cMax == r) {
        h = 60 * (((g - b) / delta) % 6);
    }
    else if (cMax == g) {
        h = 60 * (((b - r) / delta) + 2);
    }
    else {
        h = 60 * (((r - g) / delta) + 4);
    }
    if (delta == 0) {
        s = 0;
    }
    else {
        s = (delta / (1 - Math.abs(2 * l - 1)))
    }
    return {
        h: h,
        s: s,
        l: l
    }
}
// expects an object and returns a string
export function hslToRGB(hsl) {
    var h = hsl.h,
        s = hsl.s,
        l = hsl.l,
        c = (1 - Math.abs(2 * l - 1)) * s,
        x = c * (1 - Math.abs((h / 60) % 2 - 1)),
        m = l - c / 2,
        r, g, b;
    if (h < 60) {
        r = c;
        g = x;
        b = 0;
    }
    else if (h < 120) {
        r = x;
        g = c;
        b = 0;
    }
    else if (h < 180) {
        r = 0;
        g = c;
        b = x;
    }
    else if (h < 240) {
        r = 0;
        g = x;
        b = c;
    }
    else if (h < 300) {
        r = x;
        g = 0;
        b = c;
    }
    else {
        r = c;
        g = 0;
        b = x;
    }
    r = normalize_rgb_value(r, m);
    g = normalize_rgb_value(g, m);
    b = normalize_rgb_value(b, m);
    return rgbToHex(r, g, b);
}
export function normalize_rgb_value(color, m) {
    color = Math.floor((color + m) * 255);
    if (color < 0) {
        color = 0;
    }
    return color;
}
export function rgbToHex(r, g, b) {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}
// =====================================================================================
// =====================================================================================
// changeHue("#FF0000", 40) --> returns #ffaa00
// changeHue("#D61E1E", 180) --> returns #1ed6d6
// changeHue("#2244BB", -80) --> returns #21bb66
// =====================================================================================
// =====================================================================================
export function TextField(label, description, name, showAktualnoS, showAktualnoDo) {
    return {
        label: label,
        description: description,
        name: name,
        type: "text",
        propfields: {
            showAktualnoS: showAktualnoS,
            showAktualnoDo: showAktualnoDo
        },
    }
}
export function MDField(label, description, name, showAktualnoS, showAktualnoDo) {
    return {
        label: label,
        description: description,
        name: name,
        type: "func",
        propfields: {
            showAktualnoS: showAktualnoS,
            showAktualnoDo: showAktualnoDo
        },
        render: (auth, item, value, onChange, onAfterChange, isChanged, partialReplacement, contextObject, objectName, data, inputProps, wrapperProps) => {
            return (<FieldWrapper wrapperProps={wrapperProps} formItem={false} auth={auth} item={item} value={value} onChange={onChange}>
                <MDEditor
                    data-color-mode="light"
                    value={value} onChange={onChange}
                    preview={"edit"}
                    overflow={false}
                    {...inputProps}
                    style={{
                        ...inputProps?.style, width: "100%", boxShadow: "none", border: "1px solid #d9d9d9", borderRadius: "6px",
                        pointerEvents: item?.view?.disabled ? "none" : "auto",
                        opacity: item?.view?.disabled ? "0.6" : "1",
                    }}
                />
            </FieldWrapper>)
        }
    }
}
function MDXFieldComponent(props) {
    const { auth, item, value, onChange, onAfterChange, isChanged, partialReplacement, contextObject, objectName, data, inputProps, wrapperProps } = props;
    const ref = React.useRef(null)
    const [fullScreen, setFullScreen] = useState(false)

    useEffect(() => {
        if (ref?.current && value && ref?.current?.getMarkdown() != value) {
            ref?.current?.setMarkdown(value)
        }
    }, [value])
    function isDescendant(parent, child) {
        var node = child?.parentNode;
        while (node != null) {
            if (node == parent) {
                return true;
            }
            node = node?.parentNode;
        }
        return false;
    }
    const [uuidKey, setUuidkey] = useState(uuid())
    return (
        <Overlay open={fullScreen} setOpen={setFullScreen} overlayStyle={{ zIndex: "10001" }}>
            <FieldWrapper wrapperProps={wrapperProps} formItem={!!item?.formItem} auth={auth} item={item} value={value} onChange={onChange}>
                <div
                    style={{ width: "100%" }}
                    onBlur={(e) => {
                        const editor = document.getElementsByClassName(`c${uuidKey}`)?.[0]
                        if (!isDescendant(editor, e?.target) || !isDescendant(editor, e?.relatedTarget)) {
                            if (inputProps?.onBlur) {
                                inputProps?.onBlur(e?.target)
                            }
                        }
                    }}
                >
                    <MDXEditor
                        ref={ref}
                        {...inputProps}
                        onBlur={(e) => { }}
                        className={`mdx-editor-field c${uuidKey} ${inputProps?.className}`}
                        contentEditableClassName='height-250'
                        markdown={""}
                        readOnly={item?.view?.disabled}
                        trim={false}
                        // onBlur={(e)=>{e.stopPropagation(); console.log("BlurX",e);}}
                        plugins={[
                            headingsPlugin(),
                            listsPlugin(),
                            quotePlugin(),
                            markdownShortcutPlugin(),
                            codeBlockPlugin(),
                            // thematicBreakPlugin(),
                            // tablePlugin(),
                            // directivesPlugin(),
                            // linkDialogPlugin(),
                            // frontmatterPlugin(),
                            // imagePlugin(),
                            // diffSourcePlugin(),
                            toolbarPlugin({
                                // toolbarClassName: 'my-classname',
                                toolbarContents: () => (
                                    <>
                                        <UndoRedo />
                                        <BoldItalicUnderlineToggles />
                                        <CodeToggle />
                                        <InsertCodeBlock />
                                        <ListsToggle />
                                        {/* <DiffSourceToggleWrapper /> */}
                                        {/* <InsertTable /> */}
                                        {/* <InsertThematicBreak /> */}
                                        {/* <BlockTypeSelect /> */}
                                        {/* <div
                                            style={{
                                                cursor: "pointer",
                                            }}
                                            onClick={(e) => { (fullScreen) ? setFullScreen(false) : setFullScreen(true) }}
                                        >
                                            {(!fullScreen) && <FullscreenOutlined />}
                                            {(fullScreen) && <FullscreenExitOutlined />}
                                        </div> */}
                                    </>
                                )
                            })
                        ]}
                        onChange={onChange}
                    />
                </div>
            </FieldWrapper>
        </Overlay>
    )
}
export function MDXField(label, description, name, showAktualnoS, showAktualnoDo) {
    return {
        label: label,
        description: description,
        name: name,
        type: "func",
        propfields: {
            showAktualnoS: showAktualnoS,
            showAktualnoDo: showAktualnoDo
        },
        render: (auth, item, value, onChange, onAfterChange, isChanged, partialReplacement, contextObject, objectName, data, inputProps, wrapperProps) => {
            return (
                <MDXFieldComponent
                    auth={auth}
                    item={item}
                    value={value}
                    onChange={onChange}
                    onAfterChange={onAfterChange}
                    isChanged={isChanged}
                    partialReplacement={partialReplacement}
                    contextObject={contextObject}
                    objectName={objectName}
                    data={data}
                    inputProps={inputProps}
                    wrapperProps={wrapperProps}
                />
            )
        }
    }
}

const b64toBlob = (b64Data, contentType = '', sliceSize = 512) => {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);

        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }

        const byteArray = new Uint8Array(byteNumbers);
        byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
}


var saveByteArray = (function () {
    var a = document.createElement("a");
    document.body.appendChild(a);
    a.style = "display: none";
    return function (data, name, type) {
        var blob = b64toBlob(data, type),
            url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = name;
        a.click();
        window.URL.revokeObjectURL(url);
    };
}());


function ImagesFieldComponent(props) {
    const { auth, item, value, onChange, onAfterChange, isChanged, partialReplacement, contextObject, objectName, data, inputProps, wrapperProps } = props;
    const ref = React.useRef(null)
    const iref = React.useRef(null)
    const [fullScreen, setFullScreen] = useState(false)
    function isDescendant(parent, child) {
        var node = child?.parentNode;
        while (node != null) {
            if (node == parent) {
                return true;
            }
            node = node?.parentNode;
        }
        return false;
    }
    const [uuidKey, setUuidkey] = useState(uuid())
    const [files, setFiles] = useState([]);
    const uploadingProps = useMemo(() => ({
        maxCount: 1,
        name: 'files',
        listType: "picture-card",
        multiple: false,
        showUploadList: false, //item.showUploadList,
        accept: item.accept,

        beforeUpload: (file, fileList) => {
            // const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
            // if (!isJpgOrPng) {
            //     message.error('You can only upload JPG/PNG file!');
            //     return false;
            // }
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                message.error('Файл должен быть менее 50MB!');
                return false;
            }

            setFiles(o => [...o, file]);

            if (onChange) {
                onChange({
                    // ID: v?.ID,
                    // opisanie: v?.opisanie,
                    file: file,
                    // value: v?.value,
                    // aktualnoS: v?.aktualnoS,
                    // aktualnoDo: v?.aktualnoDo,
                });
            }

            return false;
        },
        fileList: files,
    }), [item, files, onChange]);

    const deletefield = useCallback(() => {
        Modal.confirm({
            title: `Удалить все файлы`,
            icon: <ExclamationCircleOutlined />,
            content: (<div>
                <div>Вы уверены что хотите удалить все файлы?</div>
            </div>),
            okText: "Да",
            okType: 'danger',
            cancelText: "Нет",
            onOk: () => {
                if (onChange) {
                    onChange(undefined);
                }
            },
        });
    }, [onChange])

    const deletevalue = useCallback((itemvalue) => {
        Modal.confirm({
            title: `Удалить файл`,
            icon: <ExclamationCircleOutlined />,
            content: (<div>
                <div>Вы уверены что хотите удалить файл?</div>
            </div>),
            okText: "Да",
            okType: 'danger',
            cancelText: "Нет",
            onOk: () => {
                if (onChange) {
                    onChange({
                        ID: itemvalue?.ID
                    });
                }
            },
        });
    }, [onChange])

    const base_size = 128;
    var pixels = base_size * base_size;

    // if (item?.cropProps?.aspect > 1) {
    //     pixels = pixels * item?.cropProps?.aspect / 1.5;
    // } else if (item?.cropProps?.aspect < 1) {
    //     pixels = pixels / item?.cropProps?.aspect / 1.5;
    // }

    var width = _.toInteger(_.round(Math.sqrt(pixels * item?.cropProps?.aspect)))
    var height = _.toInteger(_.round(pixels / width))

    // console.log(
    //     iref?.current?.offsetWidth,
    //     iref?.current?.clientWidth
    // );

    return (
        <Overlay open={fullScreen} setOpen={setFullScreen} overlayStyle={{ zIndex: "10001" }}>
            <FieldWrapper wrapperProps={wrapperProps} formItem={false} auth={auth} item={item}>
                <div
                    style={{ width: "100%" }}
                    onBlur={(e) => {
                        const editor = document.getElementsByClassName(`c${uuidKey}`)?.[0]
                        if (!isDescendant(editor, e?.target) || !isDescendant(editor, e?.relatedTarget)) {
                            if (inputProps?.onBlur) {
                                inputProps?.onBlur(e?.target)
                            }
                        }
                    }}
                >
                    <div ref={ref}
                        {...inputProps}
                        onBlur={(e) => { }}
                        className={`c${uuidKey} ${inputProps?.className}`}>
                        <div style={{
                            borderRadius: "6px", backgroundColor: "#f0f0f3", padding: "3px", margin: "3px",
                            display: "flex", justifyContent: ((!item?.limit || ((value?.length || 0) < item?.limit))) ? "space-between" : "flex-end", gap: "3px"
                        }}>

                            {(!item?.limit || ((value?.length || 0) < item?.limit)) && <ImgCrop
                                key={uuid()}
                                minZoom={1}
                                maxZoom={7}
                                quality={0.9}
                                rotationSlider
                                {...item?.cropProps}
                            >
                                <Upload
                                    key={item?.name}
                                    {...uploadingProps}
                                    data-locator={getLocator(item?.name)}
                                    {...inputProps}  {...item?.inputProps}
                                    listType={undefined}
                                >
                                    {!item.trigger && <Tooltip title="Загрузить файл">
                                        <div className={`bg bg-grey pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                            <PlusOutlined />
                                        </div>
                                    </Tooltip>}
                                    {item?.trigger && item?.trigger()}
                                </Upload>
                            </ImgCrop>}

                            <Tooltip title="Удалить все файлы">
                                <div className={`bg bg-grey pointer`} onClick={() => deletefield()} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                    <DeleteOutlined />
                                </div>
                            </Tooltip>
                        </div>
                        <div ref={iref} style={{ display: "flex", flexWrap: "wrap", gap: "3px", margin: "3px" }}>
                            {(value && !!value?.length) && JSXMap(value, (itemvalue, index) => {
                                if (!itemvalue?.fileID) { return <React.Fragment key={index}></React.Fragment> }
                                return (<div key={itemvalue?.ID} style={{ position: "relative" }}>
                                    <Image
                                        style={{
                                            borderRadius: "6px",
                                            maxHeight: height + "px",
                                            maxWidth: width + "px",
                                            objectFit: "contain",
                                            backgroundColor: "#cfcfcf"
                                        }}
                                        width={width}
                                        height={height}
                                        src={(itemvalue?.file?.preview) ? ycStorage(auth) + ycBucket(auth) + "/" + itemvalue?.file?.preview : (itemvalue?.file?.path) ? ycStorage(auth) + ycBucket(auth) + "/" + itemvalue?.file?.path : "error"}
                                        preview={(itemvalue?.file?.path) ? {
                                            src: ycStorage(auth) + ycBucket(auth) + "/" + itemvalue?.file?.path,
                                        } : undefined}
                                        fallback="data:image/png;base64,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"
                                    />
                                    <div style={{ position: "absolute", top: "3px", right: "3px" }}>
                                        <Tooltip title="Удалить файл">
                                            <div className={`bg bg-grey pointer`} onClick={() => deletevalue(itemvalue)}
                                                style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                                <CloseOutlined />
                                            </div>
                                        </Tooltip>
                                    </div>
                                </div>)
                            })}
                            {(!item?.limit || ((value?.length || 0) < item?.limit)) && <div
                                className='field-upload'
                                style={{ width: width + "px", height: height + "px" }}
                            >
                                <ImgCrop
                                    key={uuid()}
                                    minZoom={1}
                                    maxZoom={7}
                                    quality={0.9}
                                    rotationSlider
                                    {...item?.cropProps}
                                >
                                    <Upload
                                        key={item?.name}
                                        {...uploadingProps}
                                        data-locator={getLocator(item?.name)}
                                        {...inputProps}  {...item?.inputProps}
                                    >
                                        {!item.trigger && "Загрузить"}
                                        {item?.trigger && item?.trigger()}
                                    </Upload>
                                </ImgCrop>
                            </div>}
                        </div>

                    </div>
                </div>
            </FieldWrapper>
        </Overlay>
    )
}
export function ImagesField(aspect, kind, shape, label, description, name, showAktualnoS, showAktualnoDo, limit) {
    const ratio = Aspects?.[aspect] || 1;

    const pixels = 1000;
    var width = 0;
    var height = 0;

    if (kind == "horizontal") {
        width = _.toInteger(_.round(pixels))
        height = _.toInteger(_.round(pixels / ratio))
    }

    if (kind == "vertical") {
        height = _.toInteger(_.round(pixels))
        width = _.toInteger(_.round(pixels / ratio))
    }

    return {
        label: label,
        description: description,
        name: name,
        type: "func",
        array: true,
        limit: limit,
        accept: "image/*",

        cropProps: {
            cropShape: shape,
            kind: kind,
            aspect: width / height, //Aspects?.[aspect],
            minAspect: 0.05,
            maxAspect: 9,
            modalWidth: 700,
            modalTitle: "Редактирование изображения",
        },

        inputProps: {

        },

        propfields: {
            showAktualnoS: showAktualnoS,
            showAktualnoDo: showAktualnoDo
        },
        render: (auth, item, value, onChange, onAfterChange, isChanged, partialReplacement, contextObject, objectName, data, inputProps, wrapperProps) => {
            return (
                <ImagesFieldComponent
                    auth={auth}
                    item={item}
                    value={value}
                    onChange={onChange}
                    onAfterChange={onAfterChange}
                    isChanged={isChanged}
                    partialReplacement={partialReplacement}
                    contextObject={contextObject}
                    objectName={objectName}
                    data={data}
                    inputProps={inputProps}
                    wrapperProps={wrapperProps}
                />
            )
        }
    }
}


function VideosFieldComponent(props) {
    const { auth, item, value, onChange, onAfterChange, isChanged, partialReplacement, contextObject, objectName, data, inputProps, wrapperProps } = props;
    const ref = React.useRef(null)
    const iref = React.useRef(null)
    const [fullScreen, setFullScreen] = useState(false)
    function isDescendant(parent, child) {
        var node = child?.parentNode;
        while (node != null) {
            if (node == parent) {
                return true;
            }
            node = node?.parentNode;
        }
        return false;
    }
    const [uuidKey, setUuidkey] = useState(uuid())
    const [files, setFiles] = useState([]);
    const uploadingProps = useMemo(() => ({
        maxCount: 1,
        name: 'files',
        listType: "picture-card",
        multiple: false,
        showUploadList: false,
        accept: item.accept,
        beforeUpload: (file, fileList) => {
            // const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
            // if (!isJpgOrPng) {
            //     message.error('You can only upload JPG/PNG file!');
            //     return false;
            // }
            const isLt2M = file.size / 1024 / 1024 < 50;
            if (!isLt2M) {
                message.error('Файл должен быть менее 50MB!');
                return false;
            }

            setFiles(o => [...o, file]);

            if (onChange) {
                onChange({
                    file: file,
                });
            }

            return false;
        },
        fileList: files,
    }), [item, files, onChange]);

    const deletefield = useCallback(() => {
        Modal.confirm({
            title: `Удалить все файлы`,
            icon: <ExclamationCircleOutlined />,
            content: (<div>
                <div>Вы уверены что хотите удалить все файлы?</div>
            </div>),
            okText: "Да",
            okType: 'danger',
            cancelText: "Нет",
            onOk: () => {
                if (onChange) {
                    onChange(undefined);
                }
            },
        });
    }, [onChange])

    const deletevalue = useCallback((itemvalue) => {
        Modal.confirm({
            title: `Удалить файл`,
            icon: <ExclamationCircleOutlined />,
            content: (<div>
                <div>Вы уверены что хотите удалить файл?</div>
            </div>),
            okText: "Да",
            okType: 'danger',
            cancelText: "Нет",
            onOk: () => {
                if (onChange) {
                    onChange({
                        ID: itemvalue?.ID
                    });
                }
            },
        });
    }, [onChange])

    const base_size = 260;
    const aspect = 1;
    var pixels = base_size * base_size;

    var width = _.toInteger(_.round(Math.sqrt(pixels * aspect))) || base_size
    var height = _.toInteger(_.round(pixels / width)) || base_size

    return (
        <Overlay open={fullScreen} setOpen={setFullScreen} overlayStyle={{ zIndex: "10001" }}>
            <FieldWrapper wrapperProps={wrapperProps} formItem={false} auth={auth} item={item}>
                <div
                    style={{ width: "100%" }}
                    onBlur={(e) => {
                        const editor = document.getElementsByClassName(`c${uuidKey}`)?.[0]
                        if (!isDescendant(editor, e?.target) || !isDescendant(editor, e?.relatedTarget)) {
                            if (inputProps?.onBlur) {
                                inputProps?.onBlur(e?.target)
                            }
                        }
                    }}
                >
                    <div ref={ref}
                        {...inputProps}
                        onBlur={(e) => { }}
                        className={`c${uuidKey} ${inputProps?.className}`}>
                        <div style={{
                            borderRadius: "6px", backgroundColor: "#f0f0f3", padding: "3px", margin: "3px",
                            display: "flex", justifyContent: ((!item?.limit || ((value?.length || 0) < item?.limit))) ? "space-between" : "flex-end", gap: "3px"
                        }}>

                            {(!item?.limit || ((value?.length || 0) < item?.limit)) &&
                                <Upload
                                    key={item?.name}
                                    {...uploadingProps}
                                    data-locator={getLocator(item?.name)}
                                    {...inputProps}  {...item?.inputProps}
                                    listType={undefined}
                                >
                                    {!item.trigger && <Tooltip title="Загрузить файл">
                                        <div className={`bg bg-grey pointer`} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                            <PlusOutlined />
                                        </div>
                                    </Tooltip>}
                                    {item?.trigger && item?.trigger()}
                                </Upload>}

                            <Tooltip title="Удалить все файлы">
                                <div className={`bg bg-grey pointer`} onClick={() => deletefield()} style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                    <DeleteOutlined />
                                </div>
                            </Tooltip>
                        </div>
                        <div ref={iref} style={{ display: "flex", flexWrap: "wrap", gap: "3px", margin: "3px" }}>
                            {(value && !!value?.length) && JSXMap(value, (itemvalue, index) => {
                                if (!itemvalue?.fileID) { return <React.Fragment key={index}></React.Fragment> }
                                return (<div key={itemvalue?.ID} style={{ position: "relative" }}>
                                    {itemvalue?.file?.fileType?.groupe == "image" && <Image
                                        style={{
                                            borderRadius: "6px",
                                            maxHeight: height + "px",
                                            maxWidth: width + "px",
                                            objectFit: "contain",
                                            backgroundColor: "#cfcfcf"
                                        }}
                                        width={width}
                                        height={height}
                                        src={(itemvalue?.file?.preview) ? ycStorage(auth) + ycBucket(auth) + "/" + itemvalue?.file?.preview : (itemvalue?.file?.path) ? ycStorage(auth) + ycBucket(auth) + "/" + itemvalue?.file?.path : "error"}
                                        preview={(itemvalue?.file?.path) ? {
                                            src: ycStorage(auth) + ycBucket(auth) + "/" + itemvalue?.file?.path,
                                        } : undefined}
                                        fallback="data:image/png;base64,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"
                                    />}
                                    {itemvalue?.file?.fileType?.groupe == "video" &&
                                        <video
                                            src={ycStorage(auth) + ycBucket(auth) + "/" + itemvalue?.file?.path}
                                            poster={(itemvalue?.file?.preview) ? ycStorage(auth) + ycBucket(auth) + "/" + itemvalue?.file?.preview : undefined}
                                            // style={{ width: "78px" }}
                                            style={{
                                                borderRadius: "6px",
                                                maxHeight: height + "px",
                                                maxWidth: width + "px",
                                                objectFit: "contain",
                                                backgroundColor: "#cfcfcf"
                                            }}
                                            width={width}
                                            height={height}
                                            controls
                                        >
                                        </video>}

                                    {/* <Image
                                        style={{
                                            borderRadius: "6px",
                                            maxHeight: height + "px",
                                            maxWidth: width + "px",
                                            objectFit: "contain",
                                            backgroundColor: "#cfcfcf"
                                        }}
                                        width={width}
                                        height={height}
                                        src={(itemvalue?.file?.path) ? ycStorage(auth) + ycBucket(auth) + "/" + itemvalue?.file?.path : "error"}
                                        fallback="data:image/png;base64,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"
                                    /> */}
                                    <div style={{ position: "absolute", top: "3px", right: "3px" }}>
                                        <Tooltip title="Удалить файл">
                                            <div className={`bg bg-grey pointer`} onClick={() => deletevalue(itemvalue)}
                                                style={{ minWidth: "25px", maxWidth: "25px", display: "flex", height: "100%", justifyContent: "center", alignItems: "center" }}>
                                                <CloseOutlined />
                                            </div>
                                        </Tooltip>
                                    </div>
                                </div>)
                            })}
                            {(!item?.limit || ((value?.length || 0) < item?.limit)) && <div
                                className='field-upload'
                                style={{ width: width + "px", height: height + "px" }}
                            >
                                <Upload
                                    key={item?.name}
                                    {...uploadingProps}
                                    data-locator={getLocator(item?.name)}
                                    {...inputProps}  {...item?.inputProps}
                                >
                                    {!item.trigger && "Загрузить"}
                                    {item?.trigger && item?.trigger()}
                                </Upload>

                            </div>}
                        </div>

                    </div>
                </div>
            </FieldWrapper>
        </Overlay>
    )
}
export function VideosField(label, description, name, showAktualnoS, showAktualnoDo, limit) {
    // const ratio = Aspects?.[aspect] || 1;

    // const pixels = 1000;
    // var width = 0;
    // var height = 0;

    // if (kind == "horizontal") {
    //     width = _.toInteger(_.round(pixels))
    //     height = _.toInteger(_.round(pixels / ratio))
    // }

    // if (kind == "vertical") {
    //     height = _.toInteger(_.round(pixels))
    //     width = _.toInteger(_.round(pixels / ratio))
    // }

    return {
        label: label,
        description: description,
        name: name,
        type: "func",
        array: true,
        limit: limit,
        accept: "video/*",

        // cropProps: {
        //     cropShape: shape,
        //     kind: kind,
        //     aspect: width / height, //Aspects?.[aspect],
        //     minAspect: 0.05,
        //     maxAspect: 9,
        //     modalWidth: 700,
        //     modalTitle: "Редактирование изображения",
        // },

        inputProps: {

        },

        propfields: {
            showAktualnoS: showAktualnoS,
            showAktualnoDo: showAktualnoDo
        },
        render: (auth, item, value, onChange, onAfterChange, isChanged, partialReplacement, contextObject, objectName, data, inputProps, wrapperProps) => {
            return (
                <VideosFieldComponent
                    auth={auth}
                    item={item}
                    value={value}
                    onChange={onChange}
                    onAfterChange={onAfterChange}
                    isChanged={isChanged}
                    partialReplacement={partialReplacement}
                    contextObject={contextObject}
                    objectName={objectName}
                    data={data}
                    inputProps={inputProps}
                    wrapperProps={wrapperProps}
                />
            )
        }
    }
}

//-------------------------------------------------------------------------------------------

export function MaxIcon({ color, width, height }) {
    return <svg style={{ marginBottom: "2px" }} xmlns="http://www.w3.org/2000/svg" width={`${width || 24}px`} height={`${height || 24}px`} viewBox="0 0 720 720"><path fill={color || "#0a0b0b"} d="M350.4,9.6C141.8,20.5,4.1,184.1,12.8,390.4c3.8,90.3,40.1,168,48.7,253.7,2.2,22.2-4.2,49.6,21.4,59.3,31.5,11.9,79.8-8.1,106.2-26.4,9-6.1,17.6-13.2,24.2-22,27.3,18.1,53.2,35.6,85.7,43.4,143.1,34.3,299.9-44.2,369.6-170.3C799.6,291.2,622.5-4.6,350.4,9.6h0ZM269.4,504c-11.3,8.8-22.2,20.8-34.7,27.7-18.1,9.7-23.7-.4-30.5-16.4-21.4-50.9-24-137.6-11.5-190.9,16.8-72.5,72.9-136.3,150-143.1,78-6.9,150.4,32.7,183.1,104.2,72.4,159.1-112.9,316.2-256.4,218.6h0Z" /></svg>
}